export const CORDER_SIDE_BAR = [
	{
		portal: 'corder_api',
		apiFolder: [
			// _______ Authentication _________
			{
				name: 'authentication',
				bold: 'true',
				id: 'authentication',
				description: 'authentication_api_description',
				types: [
					{
						name: 'login',
						id: 'login'
					},
					{
						name: 'forgot_password',
						id: 'forgot-password'
					},
					{
						name: 'change_password',
						id: 'change-password'
					},
					{
						name: 'logon',
						id: 'logon'
					},
					{
						name: 'login_with_sso',
						id: 'login-with-sso'
					},
					{
						name: 'me',
						id: 'me'
					},
					{
						name: 'google_api_login',
						id: 'google-api-login'
					},
					{
						name: 'send_otp',
						id: 'send-otp'
					},
					{
						name: 'verify_otp',
						id: 'verify-otp'
					},
				]
			},

			// _______ 2FA Authentication _________
			{
				name: '2fa_authentication',
				id: '2fa-authentication',
				description: '2fa_authentication_description',
				types: [
					{
						name: 'generate_2fa',
						id: 'generate-2fa'
					},
					{
						name: 'verify_2fa',
						id: 'verify-2fa'
					},
					{
						name: 'verify_2fa_login',
						id: 'verify-2fa-login'
					},
					{
						name: 'check_2fa',
						id: 'check-2fa'
					},
					{
						name: 'change_2fa_status',
						id: 'change-2fa-status'
					},
				]
			},

			// ____________ AI Events _______________
			{
				name: 'ai_events',
				id: 'ai-events',
				description: 'ai_events_description',
				types: [
					{
						name: 'create_ai_events',
						id: 'create-ai_events',
					},
					{
						name: 'ai_events_by_candidate',
						id: 'create-ai_events-by-candiates',
					},
					{
						name: 'edit_ai_events',
						id: 'edit-ai_events'
					},
					{
						name: 'delete_ai_events',
						id: 'delete-ai_events'
					},

					{
						name: 'bulk_create_ai_events',
						id: 'bulk-create-ai_events'
					},
					{
						name: 'get_all_ai_events',
						id: 'get-all-ai_events'
					},
					{
						name: 'candidate_bulk_ai_events',
						id: 'candidate-bulk-ai-events'
					},
				]
			},

			// ____________ Alerts ___________
			{
				name: 'alert',
				id: 'alert',
				description: 'alert_description',
				types: [
					{
						name: 'create_alert',
						id: 'create-alert',
					},
					{
						name: 'edit_alert',
						id: 'edit-alert'
					},
					{
						name: 'delete_alert',
						id: 'delete-alert'
					},
					{
						name: 'get_all_alert',
						id: 'get-all-alert'
					},
					{
						name: 'search_alert',
						id: 'search-alert'
					},
					{
						name: 'bulk_edit_alert',
						id: 'bulk-edit-alert'
					},
				]
			},

			// ____________ Alerts Types ___________
			{
				name: 'alert_types',
				id: 'alert-types',
				description: 'alert_types_description',
				types: [
					{
						name: 'create_alert_type',
						id: 'create-alert-types',
					},
					{
						name: 'edit_alert_type',
						id: 'edit-alert-types'
					},
					{
						name: 'delete_alert_types',
						id: 'delete-alert-types'
					},
					{
						name: 'get_all_alert_types',
						id: 'get-all-alert-types'
					}
				]
			},

			// ____________ Analytics ___________
			{
				name: 'analytics',
				id: 'analytics',
				description: 'analytics_description',
				types: [
					{
						name: 'dashboard_stats',
						id: 'dashboard-stats',
					},
				]
			},

			// __________ Assessment ____________
			{
				name: 'assessment',
				id: 'assessment',
				description: 'assessment_description',
				types: [
					{
						name: 'create_assessment',
						id: 'create-assessment',
					},
					{
						name: 'edit_assessment',
						id: 'edit-assessment'
					},
					{
						name: 'delete_assessment',
						id: 'delete-assessment'
					},
					{
						name: 'get_all_assessment',
						id: 'get-all-assessment'
					},
					{
						name: 'search_assessment',
						id: 'search-assessment'
					},
					{
						name: 'get_staff_assessment',
						id: 'get-staff-assessment'
					},
					{
						name: 'create_staff_assessment',
						id: 'create-staff-assessment'
					},
					{
						name: 'get_candidate_assessment',
						id: 'get-candidate-assessment'
					},
					{
						name: 'update_staff_assessment',
						id: 'update-staff-assessment'
					},
					{
						name: 'create_candidate_assessment',
						id: 'create-candidate-assessment'
					},
					{
						name: 'duplicate_assessment',
						id: 'duplicate-assessment'
					},
				]
			},

			// ____________Branch ________________
			{
				name: 'branch',
				id: 'branch',
				description: 'branch_description',
				types: [
					{
						name: 'create_branch',
						id: 'create-branch',
					},
					{
						name: 'edit_branch',
						id: 'edit-branch'
					},
					{
						name: 'delete_branch',
						id: 'delete-branch'
					},
					{
						name: 'search_branches',
						id: 'search-branches'
					},
					{
						name: 'get_all_branches',
						id: 'get-all-branches'
					},
				]
			},

			// ______________ Candidates ______________
			{
				name: 'candidate',
				id: 'candidate',
				description: 'candidate_description',
				types: [
					{
						name: 'get_all_candidates',
						id: 'get-all-candidates'
					},
					{
						name: 'create_candidate',
						id: 'create-candidate',
					},
					{
						name: 'edit_candidate',
						id: 'edit-candidate'
					},
					{
						name: 'delete_candidate',
						id: 'delete-candidate'
					},
					{
						name: 'search_candidate',
						id: 'search-candidate'
					},
					{
						name: 'create_candidate_candidate',
						id: 'create-candidate-candidate'
					}
				]
			},

			// ___________ Candidate assessment status __________
			{
				name: 'candidate_assessment_status',
				id: 'candidate-assessment-status',
				description: 'candidate_assessment_status_description',
				types: [
					{
						name: 'create_candidate_assessment_status',
						id: 'create-candidate-assessment-status',
					},
					{
						name: 'edit_candidate_assessment_status',
						id: 'edit-candidate-assessment-status'
					},
					{
						name: 'delete_candidate_assessment_status',
						id: 'delete-candidate-assessment-status'
					},
					{
						name: 'get_all_candidate_assessment_status',
						id: 'get-all-candidate-assessment-status'
					},
				]
			},

			// _________ Candidtate asseement _____
			{
				name: 'candidates_assessment',
				id: 'candidates-assessment',
				description: 'candidates_assessment_description',
				types: [
					{
						name: 'create_candidates_assessment',
						id: 'create-candidates-assessment',
					},
					{
						name: 'edit_candidates_assessment',
						id: 'edit-candidates_assessment'
					},
					{
						name: 'delete_candidates_assessment',
						id: 'delete-candidates_assessment'
					},
					{
						name: 'get_all_candidates_assessments',
						id: 'get-all-candidates_assessments'
					},
					{
						name: 'search_candidate_assessment',
						id: 'search-candidate-assessment'
					},
					{
						name: 'create_custom_candidate_assessment',
						id: 'create-custom-candidate-assessment'
					},
					{
						name: 'update_custom_candidate_assessment',
						id: 'update-custom-candidate-assessment'
					},
				]
			},

			// _____________Entity _______________
			{
				name: 'entity',
				id: 'entity',
				description: 'entity_description',
				types: [
					{
						name: 'create_entity',
						id: 'create-entity',
					},
					{
						name: 'edit_entity',
						id: 'edit-entity'
					},
					{
						name: 'delete_entity',
						id: 'delete-entity'
					},
					{
						name: 'get_all_entitys',
						id: 'get-all-entitys'
					},
					{
						name: 'get_entities_by_entity_group',
						id: 'get-entities-by-entity-group'
					},
				]
			},

			// __________ Entity Group _______________
			{
				name: 'entity_group',
				id: 'entity-group',
				description: 'entity_group_description',
				types: [
					{
						name: 'create_entity_group',
						id: 'create-entity-group',
					},
					{
						name: 'edit_entity_group',
						id: 'edit-entity-group'
					},
					{
						name: 'delete_entity_group',
						id: 'delete-entity-group'
					},
					{
						name: 'get_all_entitys_group',
						id: 'get-all-entitys-group'
					},
				]
			},

			// ______________Events  ______________
			{
				name: 'event',
				id: 'event',
				description: 'event_description',
				types: [
					{
						name: 'create_event',
						id: 'create-event',
					},
					{
						name: 'event_by_candidate',
						id: 'event-by-candidate'
					},
					{
						name: 'edit_event',
						id: 'edit-event'
					},
					{
						name: 'delete_event',
						id: 'delete-event'
					},
					{
						name: 'get_all_event',
						id: 'get-all-event'
					},
					{
						name: 'create_bulk_events',
						id: 'create-bulk-events'
					},
					{
						name: 'create_candidate_bulk_events',
						id: 'create-candidate-bulk-events'
					},
				]
			},

			// ___________ Features _____________
			{
				name: 'features',
				id: 'features',
				description: 'features_description',
				types: [
					{
						name: 'create_features',
						id: 'create-features',
					},
					{
						name: 'edit_features',
						id: 'edit-features'
					},
					{
						name: 'delete_features',
						id: 'delete-features'
					},
					{
						name: 'get_all_features',
						id: 'get-all-features'
					},
				]
			},

			// ______________ General _____________
			// {
			// 	name: 'general',
			// 	id: 'general',
			// 	description: 'general_description',
			// 	types: [
			// 		{
			// 			name: 'candidate_upload_file',
			// 			id: 'candidate-upload-file',
			// 		},
			// 		{
			// 			name: 'upload_file',
			// 			id: 'upload-file'
			// 		},
			// 		{
			// 			name: 'recognition',
			// 			id: 'recognition'
			// 		},
			// 		{
			// 			name: 'info',
			// 			id: 'info'
			// 		},
			// 	]
			// },

			// ______________Instructors_____________
			{
				name: 'instructor',
				id: 'instructor',
				description: 'instructor_description',
				types: [
					{
						name: 'create_instructor',
						id: 'create-instructor',
					},
					{
						name: 'edit_instructor',
						id: 'edit-instructor'
					},
					{
						name: 'delete_instructor',
						id: 'delete-instructor'
					},
					{
						name: 'get_all_instructors',
						id: 'get-all-instructors'
					},
					{
						name: 'create_school_instructor',
						id: 'create-school-instructor',
					},
					{
						name: 'edit_school_instructor',
						id: 'edit-school-instructor',
					},
					{
						name: 'search_instructor',
						id: 'search-instructor'
					},
				]
			},

			// __________Instrctor activity _______
			{
				name: 'instructor_activity',
				id: 'instructor-activity',
				description: 'instructor_activity_description',
				types: [
					{
						name: 'create_instructor_activity',
						id: 'create-instructor-activity',
					},
					{
						name: 'edit_instructor_activity',
						id: 'edit-instructor-activity'
					},
					{
						name: 'delete_instructor_activity',
						id: 'delete-instructor-activity'
					},
					{
						name: 'get_all_instructor_activity',
						id: 'get-all-instructor_activity'
					},
					{
						name: 'search_instructor_activity',
						id: 'search-instructor-activity'
					},
				]
			},

			// ____________Playlist______________
			{
				name: 'playlist',
				id: 'playlist',
				description: 'playlist_description',
				types: [
					{
						name: 'create_playlist',
						id: 'create-playlist',
					},
					{
						name: 'edit_playlist',
						id: 'edit-playlist'
					},
					{
						name: 'delete_playlist',
						id: 'delete-playlist'
					},
					{
						name: 'search_playlist',
						id: 'search-playlist'
					},
					{
						name: 'duplicate_playlist',
						id: 'duplicate-playlist'
					},
					{
						name: 'playlist_with_sessions',
						id: 'playlist-with-sessions'
					},
					{
						name: 'edit_playlist_with_sessions',
						id: 'edit-playlist-with-sessions'
					},
					{
						name: 'get_all_playlists',
						id: 'get-all-playlists'
					},
				]
			},

			// ___________Secure feature Profile__________
			{
				name: 'Profile',
				id: 'secure-feature-profile',
				description: 'Profile_description',
				types: [
					{
						name: 'create_profile',
						id: 'create-profile',
					},
					{
						name: 'edit_profile',
						id: 'edit-profile'
					},
					{
						name: 'delete_profile',
						id: 'delete-profile'
					},
					{
						name: 'get_all_profiles',
						id: 'get-all-profiles'
					},
					{
						name: 'search_profile',
						id: 'search-profile'
					},
					{
						name: 'create_staff_profile',
						id: 'create-staff-profile'
					},
					{
						name: 'get_staff_profile',
						id: 'get-staff-profile'
					},
					{
						name: 'edit_staff_profile',
						id: 'edit-staff-profile'
					},
					{
						name: 'create_candidate_profile',
						id: 'create-candidate-profile'
					},
					{
						name: 'edit_candidate_profile',
						id: 'edit-candidate-profile'
					},
					{
						name: 'get_candidate_profile',
						id: 'get-candidate-profile'
					},
					{
						name: 'create_duplicate_profile',
						id: 'create-duplicate-profile'
					},
				]
			},

			// _________ Report __________
			{
				name: 'reports',
				id: 'reports',
				description: 'reports_description',
				types: [
					{
						name: 'average_session_duration',
						id: 'average-session-duration',
					},
					{
						name: 'time_to_process',
						id: 'time-to-process'
					},
					{
						name: 'playlist_conversion_count_and_time',
						id: 'playlist-conversion-count-and-time'
					},
				]
			},

			// ____________ Feature Set / Role ____________
			{
				name: 'role',
				id: 'role',
				description: 'role_description',
				types: [
					{
						name: 'create_role',
						id: 'create-role',
					},
					{
						name: 'edit_role',
						id: 'edit-role'
					},
					{
						name: 'delete_role',
						id: 'delete-role'
					},
					{
						name: 'get_all_role',
						id: 'get-all-role'
					},
				]
			},

			// ____________ School ________________
			{
				name: 'school',
				id: 'school',
				description: 'school_description',
				types: [
					{
						name: 'create_school',
						id: 'create-school',
					},
					{
						name: 'edit_school',
						id: 'edit-school'
					},
					{
						name: 'delete_school',
						id: 'delete-school'
					},
					{
						name: 'get_all_school',
						id: 'get-all-school'
					},
					{
						name: 'get_staff_school',
						id: 'get-staff-school'
					},
					{
						name: 'get_public_school',
						id: 'get-public-school'
					},
				]
			},

			// _____________ Evaluation ________________
			{
				name: 'session_evaluation',
				id: 'session-evaluation',
				description: 'session_evaluation_description',
				types: [
					{
						name: 'create_session_evaluation',
						id: 'create-session-evaluation',
					},
					{
						name: 'edit_session_evaluation',
						id: 'edit-session-evaluation'
					},
					{
						name: 'delete_session_evaluation',
						id: 'delete-session-evaluation'
					},
					{
						name: 'get_all_session_evaluation',
						id: 'get-session-evaluation'
					},
					{
						name: 'create_bulk_evaluation',
						id: 'create-bulk-evaluation'
					},
					{
						name: 'edit_bulk_evaluation',
						id: 'edit-bulk-evaluation'
					},
					{
						name: 'search_evaluation',
						id: 'search-evaluation'
					},
				]
			},

			// ___________ School Credentials _____________
			// {
			// 	name: 'school_credentials',
			// 	id: 'school-credentials',
			// 	description: 'school_credentials_description',
			// 	types: [
			// 		{
			// 			name: 'create_school_credentials',
			// 			id: 'create-school-credentials',
			// 		},
			// 		{
			// 			name: 'edit_school_credentials',
			// 			id: 'edit-school-credentials'
			// 		},
			// 		{
			// 			name: 'delete_school_credentials',
			// 			id: 'delete-school-credentials'
			// 		},
			// 		{
			// 			name: 'search_school_credentials',
			// 			id: 'search-school-credentials'
			// 		},
			// 		{
			// 			name: 'get_school_credentials',
			// 			id: 'get-school-credentials'
			// 		},
			// 	]
			// },

			// ___________ Sessions _____________
			{
				name: 'Sessions',
				id: 'sessions',
				description: 'Sessions_description',
				types: [
					{
						name: 'get_session',
						id: 'get-session'
					},
					{
						name: 'create_session',
						id: 'create-session',
					},
					{
						name: 'edit_session',
						id: 'edit-session'
					},
					{
						name: 'delete_session',
						id: 'delete-session'
					},
					{
						name: 'search_session',
						id: 'search-session'
					},
					{
						name: 'create_candidate_session',
						id: 'create-candidate-session'
					},
					{
						name: 'edit_candidate_session',
						id: 'edit-candidate-session'
					},
				]
			},

			// ___________ Staff ______________
			{
				name: 'staffs',
				id: 'staffs',
				description: 'staffs_description',
				types: [
					{
						name: 'create_staffs',
						id: 'create-staffs',
					},
					{
						name: 'edit_staffs',
						id: 'edit-staffs'
					},
					{
						name: 'delete_staffs',
						id: 'delete-staffs'
					},
					{
						name: 'get_all_staffs',
						id: 'get-all-staffs'
					},
				]
			},
		]
	}
];

export const CORDER_ARTICLE_CONTENT = [
	{
		portal: 'corder_api',
		description: 'corder_api_description',
		content: [
			// ---------------- Authentication Group ---------------
			{
				id: 'authentication',
				heading: 'Authentication',
				groupDescription: 'authentication_group_description',
				subSections: [
					{
						id: 'login',
						heading: 'login',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/auth/token/',
						description: ['login_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'password',
									type: 'string',
									description: 'password_param_description'
								}
							]
						},
						requestObject: {
							id: 'login',
							method: "POST",
							endpoint: "/auth/token/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								email: 'john.doe@example.com',
								password: '****'
							}
						},
					},
					{
						id: 'forgot-password',
						heading: 'forgot_password',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/auth/forget_password/',
						description: ['forgot_password_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								}
							]
						},
						requestObject: {
							id: 'forgot-password',
							method: "POST",
							endpoint: "/auth/forget_password/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								email: 'john.doe@example.com',
							}
						},
					},
					{
						id: 'change-password',
						heading: 'change_password',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/auth/change-passowrd/',
						description: ['change_password_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'uid',
									type: 'string',
									description: 'uid_param_description'
								},
								{
									parameter: 'token',
									type: 'string',
									description: 'token_param_description'
								},
								{
									parameter: 'password',
									type: 'string',
									description: 'password_param_description'
								}
							]
						},
						requestObject: {
							id: 'forgot-password',
							method: "POST",
							endpoint: "/auth/change-passowrd/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								uuid: 'special characters',
								token: 'special characters',
								password: '********'
							}
						},
					},
					{
					  id: 'logon',
					  heading: 'logon',
					  httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/auth/logon/',
					  description: ['logon_api_desc'],
					  table: {
					    columns: [
					      {
					        heading: `${'parameter'}`,
					        accessor: 'parameter'
					      },
					      {
					        heading: `${'type'}`,
					        accessor: 'type'
					      },
					      {
					        heading: `${'description'}`,
					        accessor: 'description'
					      },
					    ],
					    data: [
					      {
					        parameter: 'client_id',
					        type: 'string',
					        description: 'typeof an client_id'
					      },
					      {
					        parameter: 'client_secret',
					        type: 'string',
					        description: 'unique_identifier_of_object'
					      },
					    ]
					  },
					  requestObject: {
					    id: 'logon',
					    method: "POST",
					    endpoint: "/auth/logon/",
					    host: "https://corder-api.mereos.eu/{version_number}",
					    contentType: "application/json",
					    body: {
					      "client_id": "34XXXXXXXXXXXXXXXXXXXXX",
					      "client_secret": "HZXXXXXXXXXXXXXXXXXXXXXXXXX"
					    }
					  },
					},
					{
						id: 'login-with-sso',
						heading: 'login_with_sso',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/auth/login_with_sso/',
						description: ['login_with_sso_desc'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'token',
									type: 'string',
									description: 'token_param_description'
								},
								{
									parameter: 'school_id',
									type: 'integer',
									description: 'school_id_param_description'
								},
							]
						},
						requestObject: {
							id: 'login-with-sso',
							method: "POST",
							endpoint: "/auth/login_with_sso/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"token": "*****",
								"school_id": "1"
							}
						},
					},
					{
						id: 'me',
						heading: 'user_information',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/auth/me/',
						description: ['me_api_description'],
						requestObject: {
							id: 'login',
							method: "POST",
							endpoint: "/auth/me/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
						},
					},
					{
						id: 'google-api-login',
						heading: 'google_api_login',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/auth/google_login_api/',
						description: ['google_api_login_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'token',
									type: 'string',
									description: 'token_param_description'
								},
							]
						},
						requestObject: {
							id: 'google-api-login',
							method: "POST",
							endpoint: "/auth/google_login_api/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"token": "*****"
							}
						},
					},
					{
						id: 'send-otp',
						heading: 'send_otp',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/auth/send_otp/',
						description: ['send_otp_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								}
							]
						},
						requestObject: {
							id: 'send-otp',
							method: "POST",
							endpoint: "/auth/send_otp/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"email": "john.doe@example.com"
							}

						},
					},
					{
						id: 'verify-otp',
						heading: 'verify_otp',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/auth/verify_otp/',
						description: ['verify_otp_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'code',
									type: 'string',
									description: 'code_param_description'
								},
							]
						},
						requestObject: {
							id: 'verify-otp',
							method: "POST",
							endpoint: "/auth/verify_otp/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"email": "john.doe@example.com",
								"code": "******"
							}
						},
					}
				]
			},

			// ---------------- 2FA Authentication Group ---------------
			{
				id: '2fa-authentication',
				heading: '2FA Authentication',
				groupDescription: '2fa_authentication_group_description',
				subSections: [
					{
						id: 'generate-2fa',
						heading: 'generate_2fa',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/auth/generate_2fa/',
						description: ['generate_2fa_api_description'],
						requestObject: {
							id: 'generate-2fa',
							method: "GET",
							endpoint: "/auth/generate_2fa/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
						},
					},
					{
						id: 'verify-2fa',
						heading: 'verify_2fa',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/auth/verify_2fa/',
						description: ['verify_2fa_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'token',
									type: 'string',
									description: 'token_param_description'
								},
							]
						},
						requestObject: {
							id: 'verify-2fa',
							method: "POST",
							endpoint: "/auth/verify_2fa/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"token": "*****"
							}
						},
					},
					{
						id: 'verify-2fa-login',
						heading: 'verify_2fa_login',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/auth/verify_2fa_login/',
						description: ['verify_2fa_login_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'token',
									type: 'string',
									description: 'token_param_description'
								},
							]
						},
						requestObject: {
							id: 'verify-2fa-login',
							method: "POST",
							endpoint: "/auth/verify_2fa_login/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"token": "*****"
							}
						},
					},
					{
						id: 'check-2fa',
						heading: 'check_2fa',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/auth/check_2fa/',
						description: ['check_2fa_api_description'],
						requestObject: {
							id: 'check-2fa',
							method: "GET",
							endpoint: "/auth/check_2fa/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
						},
					},
					{
						id: 'change-2fa-status',
						heading: 'change_2fa_status',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/auth/change_2fa_status/',
						description: ['change_2fa_status_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'is_enabled',
									type: 'boolean',
									description: 'is_enabled_param_description'
								},
							]
						},
						requestObject: {
							id: 'change-2fa-status',
							method: "POST",
							endpoint: "/auth/change_2fa_status/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"is_enabled": true
							}
						},
					}
				]
			},

			// ---------------- AI Events Group ---------------
			{
				id: 'ai-events',
				heading: 'AI Events',
				groupDescription: 'ai_events_group_description',
				subSections: [
					{
						id: 'create-ai_events',
						heading: 'create_ai_events',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/sections/ai_event/',
						description: ['create_ai_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'session_id',
									type: 'integer',
									description: 'session_id_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-ai_events',
							method: "POST",
							endpoint: "/sections/ai_event/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"name": "testing one",
								"value": "testing one",
								"start_at": null,
								"end_at": null,
								"created_at": "2024-04-09T06:56:33.815630Z",
								"session_id": 25
							}
						},
					},
					{
						id: 'create-ai_events-by-candiates',
						heading: 'ai_events_by_candidate',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/v1.1.1/sessions/candidate_ai_event/',
						description: ['create_ai_event_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'session_id',
									type: 'integer',
									description: 'session_id_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-ai_events-by-candiates',
							method: "POST",
							endpoint: "/v1.1.1/sessions/candidate_ai_event/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"name": "Today Event",
								"value": "demo",
								"session_id": 28,
								"created_at": "2024-04-05T11:29:45.174557Z",
								"start_at": "2024-04-05T11:29:45.174557Z",
								"end_at": "2024-04-05T11:29:45.174557Z"
							}
						},
					},
					{
						id: 'edit-ai_events',
						heading: 'edit_ai_events',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/sections/ai_event/',
						description: ['edit_ai_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'session_id',
									type: 'integer',
									description: 'session_id_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-ai_events',
							method: "PUT",
							endpoint: "/sections/ai_event/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 2,
								"name": "testing one Updated",
								"value": "testing one Updated",
								"start_at": null,
								"end_at": null,
								"created_at": "2024-04-09T06:57:44.306142Z",
								"session_id": 25
							}
						},
					},
					{
						id: 'delete-ai_events',
						heading: 'delete_ai_events',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/sessions/ai_event/?id=2',
						description: ['delete_ai_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-ai_events',
							method: "DELETE",
							endpoint: "/sessions/ai_event/?id=2",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'bulk-create-ai_events',
						heading: 'bulk_create_ai_events',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/v1.1.1/sessions/bulk_ai_events/',
						description: ['bulk_ai_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'events',
									type: 'array',
									description: 'events_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'session_id',
									type: 'integer',
									description: 'session_id_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'bulk-create-ai_events',
							method: "POST",
							endpoint: "/v1.1.1/sessions/bulk_ai_events/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"events": [
									{
										"name": "event1",
										"value": "123",
										"session_id": 441,
										"start_at": "2025-08-28T12:00:00Z",
										"end_at": "2025-08-28T13:00:00Z"
									},
									{
										"name": "event2",
										"value": "456",
										"session_id": 441,
										"start_at": "2025-08-28T14:00:00Z",
										"end_at": "2025-08-28T15:00:00Z"
									}
								]
							}
						},
					},
					{
						id: 'get-all-ai_events',
						heading: 'get_all_ai_events',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/sessions/ai_event/?page=1&range=1&$expand=session_id.candidate_assessment.candidate.school',
						description: ['all_ai_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
							
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-ai_events',
							method: "GET",
							endpoint: "/sessions/ai_event/?page=1&range=1&$expand=session_id.candidate_assessment.candidate.school",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								page: 1,
								range: 25,
							
								order_by: "id"}
						},
					},
					{
						id: 'candidate-bulk-ai-events',
						heading: 'candidate_bulk_ai_events',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/v1.1.1/sessions/candidate_bulk_ai_events/',
						description: ['candidate_bulk_ai_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'ai_events',
									type: 'array',
									description: 'ai_events_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'session_id',
									type: 'integer',
									description: 'session_id_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'candidate-bulk-ai_events',
							method: "POST",
							endpoint: "/v1.1.1/sessions/candidate_bulk_ai_events/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"ai_events": [
									{
										"name": "event1",
										"value": "123",
										"session_id": 441,
										"start_at": "2025-08-28T12:00:00Z",
										"end_at": "2025-08-28T13:00:00Z"
									},
									{
										"name": "event2",
										"value": "456",
										"session_id": 441,
										"start_at": "2025-08-28T14:00:00Z",
										"end_at": "2025-08-28T15:00:00Z"
									},
								]
							}
						},
					}
				]
			},

			// ---------------- Alerts ---------------
			{
				id: 'alert',
				heading: 'Alerts',
				groupDescription: 'alert_group_description',
				subSections: [
					{
						id: 'create-alert',
						heading: 'create_alert',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/schools/alerts/',
						description: ['create_alert_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'alert_type',
									type: 'integer',
									description: 'alert_type_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'body',
									type: 'object',
									description: 'body_param_description'
								},
								{
									parameter: 'tags',
									type: 'object',
									description: 'tags_param_description'
								},
								{
									parameter: 'read_at',
									type: 'date',
									description: 'read_at_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-alert',
							method: "POST",
							endpoint: "/schools/alerts/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"alert_type": 1,
								"instructor": 24,
								"body": {
									"html": "<p>Hello World!</p>",
									"delta": []
								},
								"tags": {},
								"read_at": null,
								"modify_at": "2024-05-08T10:24:56.967632Z",
								"created_at": "2024-05-08T10:24:56.967691Z"
							}
						},
					},
					{
						id: 'edit-alert',
						heading: 'edit_alert',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/schools/alerts/',
						description: ['edit_alert_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'body',
									type: 'object',
									description: 'body_param_description'
								},
								{
									parameter: 'tags',
									type: 'object',
									description: 'tags_param_description'
								},
								{
									parameter: 'read_at',
									type: 'date',
									description: 'read_at_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'alert_type',
									type: 'integer',
									description: 'alert_type_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-alert',
							method: "PUT",
							endpoint: "/schools/alerts/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 2,
								"body": {
									"html": "<p>Hello World!</p>",
									"delta": []
								},
								"tags": {},
								"read_at": null,
								"modify_at": "2024-05-08T10:43:22.571341Z",
								"created_at": "2024-05-08T10:43:22.571367Z",
								"alert_type": 1,
								"instructor": 2
							}
						},
					},
					{
						id: 'delete-alert',
						heading: 'delete_alert',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/schools/alerts/?id=2',
						description: ['delete_alert_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-alert',
							method: "DELETE",
							endpoint: "/schools/alerts/?id=2",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
						}
					},
					{
						id: 'get-all-alert',
						heading: 'get_all_alert',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/schools/alerts/?id=1&page=1&range=25',
						description: ['all_alert_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
							
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-alert',
							method: "GET",
							endpoint: "/schools/alerts/?id=1&page=1&range=25",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								page: 1,
								range: 25,
							
								order_by: "id"}
						},
					},
					{
						id: 'search-alert',
						heading: 'search_alert',
						httpRequest: `GET https://corder-api.mereos.eu/{version_number}/schools/alerts_search/?search=&page=1&range=25`,
						description: ['search_alert_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
							
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'search-alert',
							method: "GET",
							endpoint: "/schools/alerts_search/?search=&page=1&range=25",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								search: 'Alert Name',
								page: 1,
								range: 25,
							
								order_by: "id"}
						},
					},
					{
						id: 'bulk-edit-alert',
						heading: 'bulk_edit_alert',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/schools/bulk_update_alerts/',
						description: ['bulk_edit_alert_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'array',
									description: 'id_param_description'
								},
								{
									parameter: 'body',
									type: 'object',
									description: 'body_param_description'
								},
								{
									parameter: 'tags',
									type: 'object',
									description: 'tags_param_description'
								},
								{
									parameter: 'read_at',
									type: 'date | null',
									description: 'read_at_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'alert_type',
									type: 'number',
									description: 'alert_type_param_description'
								},
								{
									parameter: 'instructor',
									type: 'number',
									description: 'instructor_param_description'
								}
							]
						},
						requestObject: {
							id: 'bulk-edit-alert',
							method: "PUT",
							endpoint: "/schools/bulk_update_alerts/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": [2, 4],
								"body": {
									"html": "<p>Hello World!</p>",
									"delta": []
								},
								"tags": {},
								"read_at": null,
								"modify_at": "2026-02-11T10:30:00Z",
								"created_at": "2026-02-11T10:25:00Z",
								"alert_type": 1,
								"instructor": 36
							}
						},
					}
				]
			},

			// ---------------- Alert Types Group ---------------
			{
				id: 'alert-types',
				heading: 'Alert Types',
				groupDescription: 'alert_types_group_description',
				subSections: [
					{
						id: 'create-alert-types',
						heading: 'create_alert_type',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/schools/alert_type/',
						description: ['create_alert_type_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-alert-types',
							method: "POST",
							endpoint: "/schools/alert_type/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"name": "333",
								"description": "333",
								"modify_at": "2024-05-08T10:17:42.191046Z",
								"created_at": "2024-05-08T10:17:42.191075Z"
							}
						},
					},
					{
						id: 'edit-alert-types',
						heading: 'edit_alert_type',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/schools/alert_type/',
						description: ['edit_alert_type_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-alert-types',
							method: "PUT",
							endpoint: "/schools/alert_type/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 2,
								"name": "John Doe",
								"description": "John Doe",
								"modify_at": "2024-05-08T10:57:09.359592Z",
								"created_at": "2024-05-08T10:57:09.359625Z"
							}
						},
					},
					{
						id: 'delete-alert-types',
						heading: 'delete_alert_types',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/schools/alert_type/?id=2',
						description: ['delete_alert_type_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-alert-types',
							method: "DELETE",
							endpoint: "/schools/alert_type/?id=2",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-alert-types',
						heading: 'get_all_alert_types',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/schools/alert_type/',
						description: ['all_alert_type_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'get-all-alert-types',
							method: "GET",
							endpoint: "/schools/alert_type/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								order_by: "id"
							}
						},
					}
				]
			},

			// ---------------- Analytics Group ---------------
			{
				id: 'analytics',
				heading: 'Analytics',
				groupDescription: 'analytics_group_description',
				subSections: [
					{
						id: 'dashboard-stats',
						heading: 'dashboard_stats',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/analytics/dashboard_stats/',
						description: ['dashboard_stats_api_description'],
						requestObject: {
							id: 'dashboard-stats',
							method: "GET",
							endpoint: "/analytics/dashboard_stats/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
						},
					}
				]
			},

			// ---------------- Assessment Group ---------------
			{
				id: 'assessment',
				heading: 'Assessment',
				groupDescription: 'assessment_group_description',
				subSections: [
					{
						id: 'create-assessment',
						heading: 'create_assessment',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/assessments/assessment/',
						description: ['create_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'course_id',
									type: 'string',
									description: 'course_id_param_description'
								},
								{
									parameter: 'branch',
									type: 'string',
									description: 'branch_param_description'
								},
								{
									parameter: 'live_proctoring',
									type: 'string',
									description: 'live_proctoring_param_description'
								},
								{
									parameter: 'others',
									type: 'object',
									description: 'others_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-assessment',
							method: "POST",
							endpoint: "/assessments/assessment/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"external_id": "",
								"name": "brain_iq_5",
								"description": "brain iq assessment",
								"course_id": "",
								"branch": "2",
								"live_proctoring": "disabled",
								"others": {
									"duration": "90 mins"
								}
							}
						},
					},
					{
						id: 'edit-assessment',
						heading: 'edit_assessment',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/assessments/assessment/',
						description: ['edit_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'course_id',
									type: 'string',
									description: 'course_id_param_description'
								},
								{
									parameter: 'others',
									type: 'object',
									description: 'others_param_description'
								},
								{
									parameter: 'live_proctoring',
									type: 'string',
									description: 'live_proctoring_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								},
								{
									parameter: 'branch',
									type: 'integer',
									description: 'branch_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-assessment',
							method: "PUT",
							endpoint: "/assessments/assessment/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"id": 81,
								"name": "Midterm ",
								"description": "Midterm assessment ",
								"external_id": "E5",
								"course_id": "01",
								"others": {
									"difficulty": "High",
									"duration": "190 mins"
								},
								"live_proctoring": "disabled",
								"created_at": "2025-03-20T08:03:53.664550Z",
								"school": 2,
								"branch": 2
							}
						},
					},
					{
						id: 'delete-assessment',
						heading: 'delete_assessment',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/assessments/assessment/?id=7',
						description: ['delete_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-assessment',
							method: "DELETE",
							endpoint: "/assessments/assessment/?id=7",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								id: 7
							}
						}
					},
					{
						id: 'get-all-assessment',
						heading: 'get_all_assessments',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/v1.1.1/assessments/assessment/?id=182&page=1&range=1&id=81&$expand=school, branch.school',
						description: ['get_staff_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-assessment',
							method: "GET",
							endpoint: "/v1.1.1/assessments/assessment/?id=182&page=1&range=1&id=81&$expand=school, branch.school",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								page: 1,
								range: 25,
							
								order_by: "id"}
						},
					},
					{
						id: 'search-assessment',
						heading: 'search_assessment',
						httpRequest: `GET https://corder-api.mereos.eu/{version_number}/v1.1.1/assessments/assessment_search/?search=1892&page=1&including_columns=&$expand=school, branch.school&range=1`,
						description: ['search_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'including_columns',
									optional: true,
									type: 'string',
									description: 'including_columns_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'search-assessment',
							method: "GET",
							endpoint: "/v1.1.1/assessments/assessment_search/?search=1892&page=1&including_columns=&$expand=school, branch.school&range=1",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								search: 'Assessment Name',
								page: 1,
								range: 25,
								q: `Q(created_at='2024-07-31T12:34:56')`,
								including_columns: 'owner'
							,
								order_by: "id"}
						},
					},
					{
						id: 'get-staff-assessment',
						heading: 'get_staff_assessment',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/assessments/staff_assessment/?id=5&page=1',
						description: ['all_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-staff-assessment',
							method: "GET",
							endpoint: "/assessments/staff_assessment/?id=5&page=1",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
						}
					},
					{
						id: 'create-staff-assessment',
						heading: 'create_staff_assessment',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/assessments/staff_assessment/',
						description: ['create_staff_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'course_id',
									type: 'string',
									description: 'course_id_param_description'
								},
								{
									parameter: 'others',
									type: 'object',
									description: 'others_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-staff-assessment',
							method: "POST",
							endpoint: "/assessments/staff_assessment/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"name": "John Doe",
								"description": "Testing",
								"external_id": "Testing",
								"course_id": "Testing",
								"others": {
									"test": "value"
								}
							}
						},
					},
					{
						id: 'get-candidate-assessment',
						heading: 'get_candidate_assessment',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/assessments/candidate_assessment/?id=5&course_id=133&external_id=169&page=1&range=1&$expand=school, branch.school',
						description: ['get_candidate_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'course_id',
									optional: true,
									type: 'integer',
									description: 'course_id_param_description'
								},
								{
									parameter: 'external_id',
									optional: true,
									type: 'integer',
									description: 'external_id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-candidate-assessment',
							method: "GET",
							endpoint: "/assessments/candidate_assessment/?id=5&course_id=133&external_id=169&page=1&range=1&$expand=school, branch.school",
							host: "candidate_assessment",
							contentType: "application/json",
						}
					},
					{
						id: 'update-staff-assessment',
						heading: 'update_staff_assessment',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/assessments/staff_assessment/',
						description: ['update_staff_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'course_id',
									type: 'string',
									description: 'course_id_param_description'
								},
								{
									parameter: 'others',
									type: 'object',
									description: 'others_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								}
							]
						},
						requestObject: {
							id: 'update-staff-assessment',
							method: "PUT",
							endpoint: "/assessments/staff_assessment/",
							host: "candidate_assessment",
							contentType: "application/json",
							body: {
								"id": 24,
								"name": "John Doe Updated",
								"description": "Testing",
								"external_id": "Testing",
								"course_id": "Testing",
								"others": {
									"test": "value"
								},
								"created_at": "2024-10-17T07:25:22.279272Z",
								"school": 1
							}
						}
					},
					{
						id: 'create-candidate-assessment',
						heading: 'create_candidate_assessment',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/assessments/candidate_assessment/',
						description: ['create_candidate_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'branch',
									type: 'integer',
									description: 'branch_param_description'
								},
								{
									parameter: 'course_id',
									type: 'integer',
									description: 'course_id_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'others',
									type: 'object',
									description: 'others_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-candidate-assessment',
							method: "POST",
							endpoint: "/assessments/candidate_assessment/",
							host: "candidate_assessment",
							contentType: "application/json",
							body: {
								"branch": 1,
								"course_id": 12,
								"description": "Assessment description",
								"name": "fastest assessment ever",
								"others": {
									"test": "value"
								},
								"external_id": "2345234"
							}
						}
					},
					{
						id: 'duplicate-assessment',
						heading: 'duplicate_assessment',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/assessment/duplicate_assessment/',
						description: ['duplicate_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'assessment_name',
									type: 'string',
									description: 'assessment_name_param_description'
								},
							]
						},
						requestObject: {
							id: 'duplicate-assessment',
							method: "POST",
							endpoint: "/assessment/duplicate_assessment/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 1234,
								"assessment_name": "assessment name",
							}
						}
					}
				]
			},

			// ---------------- Branch Group ---------------
			{
				id: 'branch',
				heading: 'Branch',
				groupDescription: 'branch_group_description',
				subSections: [
					{
						id: 'create-branch',
						heading: 'create_branch',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/schools/branch/',
						description: ['create_branch_desc'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'str',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'str',
									description: 'description_param_description'
								},
								{
									parameter: 'external_id',
									type: 'str',
									description: 'external_id_param_description'
								},
								{
									parameter: 'others',
									type: 'object',
									description: 'others_param_description'
								},
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-branch',
							method: "POST",
							endpoint: "/schools/branch/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"name": "old",
								"description": "old",
								"external_id": "old",
								"others": {},
								"school": 2
							}
						},
					},
					{
						id: 'edit-branch',
						heading: 'edit_branch',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/schools/branch/',
						description: ['edit_branch_desc'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'others',
									type: 'object',
									description: 'others_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-branch',
							method: "PUT",
							endpoint: "/schools/branch/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 3,
								"name": "old",
								"description": "old",
								"external_id": "old",
								"others": {},
								"modify_at": "2025-02-20T08:42:25.477545Z",
								"created_at": "2025-02-20T08:42:25.477559Z",
								"school": 2
							}
						},
					},
					{
						id: 'delete-branch',
						heading: 'delete_branch',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/schools/branch/?id=3',
						description: ['Delete_branch_desc'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-branch',
							method: "DELETE",
							endpoint: "/schools/branch/?id=3",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'search-branches',
						heading: 'search_branches',
						httpRequest: `GET https://corder-api.mereos.eu/{version_number}/schools/branch_search/?search=&page=1&range=1&$expand=school`,
						description: ['search_branch_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'search-branches',
							method: "GET",
							endpoint: "/schools/branch_search/?search=&page=1&range=1&$expand=school",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								search: 'Branch Name',
								page: 1,
								range: 25
							,
								order_by: "id"}
						},
					},
					{
						id: 'get-all-branches',
						heading: 'get_all_branches',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/schools/branch/?page=1&range=10&$expand=school',
						description: ['get_all_branches_desc'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
							
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-branches',
							method: "GET",
							endpoint: "/schools/branch/?page=1&range=10&$expand=school",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								page: 1,
								range: 25,
							
								order_by: "id"}
						},
					}
				]
			},

			// ---------------- Candidate Group ---------------
			{
				id: 'candidate',
				heading: 'Candidate',
				groupDescription: 'candidate_group_description',
				subSections: [
					{
						id: 'get-all-candidates',
						heading: 'get_all_candidates',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/candidates/candidate/?id=1&page=1&range=1&$expand=instructor',
						description: ['all_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-candidates',
							method: "GET",
							endpoint: "/candidates/candidate/?id=1&page=1&range=1&$expand=instructor",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								page: 1,
								range: 25,
							
								order_by: "id"}
						},
					},
					{
						id: 'create-candidate',
						heading: 'create_candidate',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/candidates/candidate/',
						description: ['create_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'photo',
									type: 'url',
									description: 'photo_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'external_name',
									type: 'string',
									description: 'external_name_param_description'
								},
								{
									parameter: 'section',
									type: 'string',
									description: 'section_param_description'
								},
								{
									parameter: 'class_name',
									type: 'string',
									description: 'class_name_param_description'
								},
								{
									parameter: 'dob',
									type: 'date',
									description: 'dob_param_description'
								},
								{
									parameter: 'others',
									type: 'object',
									description: 'others_param_description'
								},
								{
									parameter: 'branch',
									type: 'string',
									description: 'branch_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-candidate',
							method: "POST",
							endpoint: "/candidates/candidate/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"name": "John Doe",
								"photo": "https://example.com/photos/john_doe.jpg",
								"email": "john.doe@example.com",
								"external_id": "123",
								"external_name": "John Doe",
								"section": "A",
								"class_name": "10th Grade",
								"dob": "2005-08-15",
								"branch": "2",
								"others": {
									"nationality": "American",
									"extra_curricular": [
										"Football",
										"Debate Club"
									]
								}
							}
						},
					},
					{
						id: 'edit-candidate',
						heading: 'edit_candidate',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/candidates/candidate/',
						description: ['edit_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'photo',
									type: 'url',
									description: 'photo_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'external_name',
									type: 'string',
									description: 'external_name_param_description'
								},
								{
									parameter: 'section',
									type: 'string',
									description: 'section_param_description'
								},
								{
									parameter: 'class_name',
									type: 'string',
									description: 'class_name_param_description'
								},
								{
									parameter: 'branch',
									type: 'integer',
									description: 'branch_param_description'
								},
								{
									parameter: 'dob',
									type: 'date',
									description: 'dob_param_description'
								},
								{
									parameter: 'others',
									type: 'object',
									description: 'others_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-candidate',
							method: "PUT",
							endpoint: "/candidates/candidate/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"id": 625,
								"school": 2,
								"name": "John Doe Updated",
								"email": "john.doe@example.com",
								"photo": "https://example.com/photos/john_doe.jpg",
								"external_id": "123",
								"external_name": "John Doe",
								"section": "A",
								"class_name": "10th Grade",
								"branch": 2,
								"dob": "2005-07-15",
								"others": {
									"nationality": "American",
									"extra_curricular": [
										"Football",
										"Debate Club",
										"Cricket"
									]
								},
								"created_at": "2025-03-20T08:18:28.907670Z"
							}
						},
					},
					{
						id: 'delete-candidate',
						heading: 'delete_candidate',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/candidates/candidate/?id=1',
						description: ['delete_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-candidate',
							method: "DELETE",
							endpoint: "/candidates/candidate/?id=1",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								id: 1,
							}
						}
					},
					{
						id: 'search-candidate',
						heading: 'search_candidate',
						httpRequest: `GET https://corder-api.mereos.eu/{version_number}/candidates/candidate_search/?search=mereos dashboard&page=1&range=20&including_columns=&$expand=school, branch.school`,
						description: ['search_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'including_columns',
									optional: true,
									type: 'string',
									description: 'including_columns_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'search-candidate',
							method: "GET",
							endpoint: "/candidates/candidate_search/?search=mereos dashboard&page=1&range=20&including_columns=&$expand=school, branch.school",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								search: 'Candiate Name',
								page: 1,
								range: 25,
								q: `Q(created_at='2024-07-31T12:34:56')`,
								including_columns: 'owner'
							,
								order_by: "id"}
						},
					},
					{
						id: 'create-candidate-candidate',
						heading: 'create_candidate_candidate',
						httpRequest: `POST https://corder-api.mereos.eu/{version_number}/candidates/candidate_candidate/`,
						description: ['create_candidate_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'photo',
									type: 'url',
									description: 'photo_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'external_name',
									type: 'string',
									description: 'external_name_param_description'
								},
								{
									parameter: 'section',
									type: 'integer',
									description: 'section_param_description'
								},
								{
									parameter: 'class_name',
									type: 'string',
									description: 'class_name_param_description'
								},
								{
									parameter: 'branch',
									type: 'integer',
									description: 'branch_param_description'
								},
								{
									parameter: 'dob',
									type: 'string',
									description: 'dob_param_description'
								},
								{
									parameter: 'others',
									type: 'object',
									description: 'others_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-candidate-candidate',
							method: "POST",
							endpoint: "/candidates/candidate_candidate/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"school": 2,
								"name": "John Doe",
								"email": "john.doe@example.com",
								"photo": null,
								"external_id": "3",
								"external_name": "2",
								"section": null,
								"class_name": null,
								"branch": 4,
								"dob": null,
								"others": {},
								"modify_at": "2025-04-14T11:04:42.443449Z",
								"created_at": "2025-04-14T11:04:42.443460Z"
							}
						},
					}
				]
			},

			// ---------------- Candidate Assessment Status Group ---------------
			{
				id: 'candidate-assessment-status',
				heading: 'Candidate Assessment Status',
				groupDescription: 'candidate_assessment_status_group_description',
				subSections: [
					{
						id: 'create-candidate-assessment-status',
						heading: 'create_candidate_assessment_status',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/candidate/candidate_assessment_status/',
						description: ['create_candidate_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-candidate-assessment-status',
							method: "POST",
							endpoint: "/candidate/candidate_assessment_status/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"name": "Completed"
							}
						},
					},
					{
						id: 'edit-candidate-assessment-status',
						heading: 'edit_candidate_assessment_status',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/candidate/candidate_assessment_status/',
						description: ['edit_candidate_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-candidate-assessment-status',
							method: "PUT",
							endpoint: "/candidate/candidate_assessment_status/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 7,
								"name": "New",
								"created_at": "2023-10-25T12:10:25.149490Z"
							}
						},
					},
					{
						id: 'delete-candidate-assessment-status',
						heading: 'delete_candidate_assessment_status',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/candidate/candidate_assessment_status/?id=7',
						description: ['delete_candidate_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-candidate-assessment-status',
							method: "DELETE",
							endpoint: "/candidate/candidate_assessment_status/?id=7",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								id: "7"
							}
						}
					},
					{
						id: 'get-all-candidate-assessment-status',
						heading: 'get_all_candidate_assessment_status',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/candidate/candidate_assessment_status/',
						description: ['all_candidate_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'get-all-candidates',
							method: "GET",
							endpoint: "/candidate/candidate_assessment_status/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								order_by: "id"
							}
						},
					}
				]
			},

			// ---------------- Candidates Assessment Group ---------------
			{
				id: 'candidates-assessment',
				heading: 'Candidates Assessment',
				groupDescription: 'candidates_assessment_group_description',
				subSections: [
					{
						id: 'create-candidates-assessment',
						heading: 'create_candidates_assessment',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/candidates/candidate_assessments/',
						description: ['create_candidates_assessment_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'candidate',
									type: 'integer',
									description: 'candidate_param_description'
								},
								{
									parameter: 'assessment',
									type: 'integer',
									description: 'assessment_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-candidates-assessment',
							method: "POST",
							endpoint: "/candidates/candidate_assessments/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"status": "Pending",
								"created_at": "2023-10-24T12:21:50.195061Z",
								"candidate": 177,
								"assessment": 149
							}
						},
					},
					{
						id: 'edit-candidates_assessment',
						heading: 'edit_candidates_assessment',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/candidates/candidate_assessments/',
						description: ['edit_candidates_assessment_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'candidate',
									type: 'integer',
									description: 'candidate_param_description'
								},
								{
									parameter: 'assessment',
									type: 'integer',
									description: 'assessment_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-candidates_assessment',
							method: "PUT",
							endpoint: "/candidates/candidate_assessments/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 2,
								"status": "Result",
								"created_at": "2023-10-24T12:33:16.381094Z",
								"candidate": 177,
								"assessment": 149
							}
						},
					},
					{
						id: 'delete-candidates_assessment',
						heading: 'delete_candidates_assessment',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/candidates/candidate_assessments/?id=2',
						description: ['delete_candidates_assessment_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-candidates_assessment',
							method: "DELETE",
							endpoint: "/candidates/candidate_assessments/?id=2",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								id: 2
							}
						}
					},
					{
						id: 'get-all-candidates_assessments',
						heading: 'get_all_candidates_assessments',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/candidates/candidate_assessments/?id=332&candidate__email=john.doe@example.com&assessment__id=5&page=1&range=1&$expand=profile',
						description: ['all_candidates_assessment_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'candidate__email',
									optional: true,
									type: 'string',
									description: 'candidate__email_param_description'
								},
								{
									parameter: 'assessment__id',
									optional: true,
									type: 'integer',
									description: 'assessment__id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-candidates_assessments',
							method: "GET",
							endpoint: "/candidates/candidate_assessments/?id=332&candidate__email=john.doe@example.com&assessment__id=5&page=1&range=1&$expand=profile",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
						},
					},
					{
						id: 'search-candidate-assessment',
						heading: 'search_candidate_assessment',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/candidates/candidate_assessment_search/?page=1&range=25&q=Q(name__icontains=\"demo\"&$expand=school&including_columns=name',
						description: ['search_candidates_assessment_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'including_columns',
									optional: true,
									type: 'string',
									description: 'including_columns_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'search-candidate-assessment',
							method: "GET",
							endpoint: "/candidates/candidate_assessment_search/?page=1&range=25&q=Q(name__icontains=\"demo\"&$expand=school&including_columns=name",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"page": 1,
								"range": 25,
								"attach_score": true
							,
								order_by: "id"}
						},
					},
					{
						id: 'create-custom-candidate-assessment',
						heading: 'create_custom_candidate_assessment',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/candidates/custom_candidate_assessment/',
						description: ['create_custom_candidate_assessment_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'candidate',
									type: 'integer',
									description: 'candidate_param_description'
								},
								{
									parameter: 'assessment',
									type: 'integer',
									description: 'assessment_param_description'
								},
								{
									parameter: 'profile',
									type: 'integer',
									description: 'profile_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-custom-candidate-assessment',
							method: "POST",
							endpoint: "/candidates/custom_candidate_assessment/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"status": "Initiated",
								"candidate": 1,
								"assessment": 25,
								"profile": 12
							}
						},
					},
					{
						id: 'update-custom-candidate-assessment',
						heading: 'update_custom_candidate_assessment',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/candidates/custom_candidate_assessment/',
						description: ['update_custom_candidate_assessment_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								}
							]
						},
						requestObject: {
							id: 'update-custom-candidate-assessment',
							method: "PUT",
							endpoint: "/candidates/custom_candidate_assessment/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 17,
								"status": "Initiated"
							}
						},
					}
				]
			},

			// ---------------- Entity Group ---------------
			{
				id: 'entity',
				heading: 'Entity',
				groupDescription: 'entity_group_description',
				subSections: [
					{
						id: 'create-entity',
						heading: 'create_entity',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/profiles/entity/',
						description: ['create_entity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'key',
									type: 'string',
									description: 'key_param_description'
								},
								{
									parameter: 'entity_group',
									type: 'integer',
									description: 'entity_group_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-entity',
							method: "POST",
							endpoint: "/profiles/entity/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"name": "demo",
								"description": "demo",
								"key": "demo",
								"entity_group": 2,
								"status": "Active",
								"school": 24
							}
						},
					},
					{
						id: 'edit-entity',
						heading: 'edit_entity',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/profiles/entity/',
						description: ['edit_entity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'key',
									type: 'string',
									description: 'key_param_description'
								},
								{
									parameter: 'entity_group',
									type: 'integer',
									description: 'entity_group_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-entity',
							method: "PUT",
							endpoint: "/profiles/entity/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"id": 2,
								"name": "demo-update",
								"description": "demo-update",
								"key": "demo-update",
								"entity_group": 2
							}
						},
					},
					{
						id: 'delete-entity',
						heading: 'delete_entity',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/profiles/entity/?id=2',
						description: ['delete_entity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-entity',
							method: "DELETE",
							endpoint: "/profiles/entity/?id=2",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"id": 2
							}
						}
					},
					{
						id: 'get-all-entitys',
						heading: 'get_all_entitys',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/profiles/entity/',
						description: ['all_entity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'get-all-entitys',
							method: "GET",
							endpoint: "/profiles/entity/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								order_by: "id"
							}
						},
					},
					{
						id: 'get-entities-by-entity-group',
						heading: 'get_entities_by_entity_group',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/profiles/get_entites_by_entity_group/',
						description: ['get_entities_by_entity_group_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'get-entities-by-entity-group',
							method: "GET",
							endpoint: "/profiles/get_entites_by_entity_group/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								order_by: "id"
							}
						},
					}
				]
			},

			// ---------------- Entity Group ---------------
			{
				id: 'entity-group',
				heading: 'Entity Group',
				groupDescription: 'entity_group_group_description',
				subSections: [
					{
						id: 'create-entity-group',
						heading: 'create_entity_group',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/profiles/entity_group/',
						description: ['create_entity_group_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'key',
									type: 'string',
									description: 'key_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-entity-group',
							method: "POST",
							endpoint: "/profiles/entity_group/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"name": "The Testing Group",
								"description": "Calculator",
								"key": "demo"
							}
						},
					},
					{
						id: 'edit-entity-group',
						heading: 'edit_entity_group',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/profiles/entity_group/',
						description: ['edit_entity_group_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'key',
									type: 'string',
									description: 'key_param_description'
								},
							]
						},
						requestObject: {
							id: 'edit-entity-group',
							method: "PUT",
							endpoint: "/profiles/entity_group/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"id": "3",
								"name": "The Testing Group",
								"description": "Calculator",
								"key": "demo"
							}
						},
					},
					{
						id: 'delete-entity-group',
						heading: 'delete_entity_group',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/profile/entity_group/',
						description: ['delete_entity_group_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-entity-group',
							method: "DELETE",
							endpoint: "/profile/entity_group/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-entitys-group',
						heading: 'get_all_entity_groups',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/profiles/entity_group/',
						description: ['all_entity_group_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'get-all-entitys-group',
							method: "GET",
							endpoint: "/profiles/entity_group/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								order_by: "id"
							}
						},
					}
				]
			},

			// ---------------- Events Group ---------------
			{
				id: 'event',
				heading: 'Events',
				groupDescription: 'event_group_description',
				subSections: [
					{
						id: 'create-event',
						heading: 'create_event',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/sessions/event/',
						description: ['create_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'session_id',
									type: 'integer',
									description: 'session_id_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-event',
							method: "POST",
							endpoint: "/sessions/event/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"name": "Testing Demo One",
								"value": "demo",
								"session_id": 441,
								"created_at": "2024-02-15T11:29:45.174557Z"
							}
						},
					},
					{
						id: 'event-by-candidate',
						heading: 'event_by_candidate',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/v1.1.1/sessions/candidate_event/',
						description: ['create_event_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'session_id',
									type: 'integer',
									description: 'session_id_param_description'
								}
							]
						},
						requestObject: {
							id: 'event-by-candidate',
							method: "POST",
							endpoint: "/v1.1.1/sessions/candidate_event/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"name": "session_started",
								"start_at": "2025-08-29T13:00:00Z",
								"session_id": 2698
							}
						},
					},
					{
						id: 'edit-event',
						heading: 'edit_event',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/sessions/event/',
						description: ['edit_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'session_id',
									type: 'string',
									description: 'session_id_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-event',
							method: "PUT",
							endpoint: "/sessions/event/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 3,
								"name": "Testing Demo One Updated",
								"value": "demo Updated",
								"session_id": "demo Updated",
								"created_at": "2024-02-15T12:01:31.806468Z"
							}
						},
					},
					{
						id: 'delete-event',
						heading: 'delete_event',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/sessions/event/?id=2',
						description: ['delete_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-event',
							method: "DELETE",
							endpoint: "/sessions/event/?id=2",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 2
							}
						}
					},
					{
						id: 'get-all-event',
						heading: 'get_all_event',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/sessions/event/?id=2&page=1&range=1&$expand=session_id',
						description: ['all_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-event',
							method: "GET",
							endpoint: "/sessions/event/?id=2&page=1&range=1&$expand=session_id",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								page: 1,
								range: 25,
							
								order_by: "id"}
						},
					},
					{
						id: 'create-bulk-events',
						heading: 'create_bulk_events',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/v1.1.1/sessions/bulk_events/',
						description: ['create_bulk_events_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'events',
									type: 'array',
									description: 'events_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-bulk-events',
							method: "POST",
							endpoint: "/v1.1.1/sessions/bulk_events/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"events": [
									{
										"name": "event1",
										"value": "123",
										"session_id": 2695,
										"start_at": "2025-08-28T12:00:00Z",
										"end_at": "2025-08-28T13:00:00Z"
									},
									{
										"name": "event2",
										"value": "456",
										"session_id": 2695,
										"start_at": "",
										"end_at": "2025-08-28T15:00:00Z"
									},
								]
							}
						},
					},
					{
						id: 'create-candidate-bulk-events',
						heading: 'create_candidate_bulk_events',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/v1.1.1/sessions/candidate_bulk_events/',
						description: ['create_candidate_bulk_events_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'events',
									type: 'array',
									description: 'events_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-candidate-bulk-events',
							method: "POST",
							endpoint: "/v1.1.1/sessions/candidate_bulk_events/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"events": [
									{
										"name": "event1",
										"value": "123",
										"session_id": 441,
										"start_at": "2025-08-28T12:00:00Z",
										"end_at": "2025-08-28T13:00:00Z"
									},
									{
										"name": "event2",
										"value": "456",
										"session_id": 441,
										"start_at": "2025-08-28T14:00:00Z",
										"end_at": "2025-08-28T15:00:00Z"
									}
								]
							}
						},
					}
				]
			},

			// ---------------- Features Group ---------------
			{
				id: 'features',
				heading: 'Features',
				groupDescription: 'features_group_description',
				subSections: [
					{
						id: 'create-features',
						heading: 'create_features',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/schools/feature/',
						description: ['create_feature_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-features',
							method: "POST",
							endpoint: "/schools/feature/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"name": "view_candidate",
								"description": "These feature enable user to perform candidate related features."
							}
						},
					},
					{
						id: 'edit-features',
						heading: 'edit_features',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/schools/feature/',
						description: ['edit_feature_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-features',
							method: "PUT",
							endpoint: "/schools/feature/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"id": 3,
								"name": "view_candidate",
								"description": "These feature enable user to perform candidate related features."
							}
						},
					},
					{
						id: 'delete-features',
						heading: 'delete_features',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/schools/feature/',
						description: ['delete_feature_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-features',
							method: "DELETE",
							endpoint: "/schools/feature/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-features',
						heading: 'get_all_features',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/schools/feature/',
						description: ['all_feature_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'get-all-features',
							method: "GET",
							endpoint: "/schools/feature/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								order_by: "id"
							}
						},
					}
				]
			},

			// ---------------- General Group ---------------
			// {
			//   id: 'general',
			//   heading: 'General',
			//   groupDescription: 'general_group_description',
			//   subSections: [
			//     {
			//       id: 'candidate-upload-file',
			//       heading: 'candidate_upload_file',
			//       httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/general/candidate_upload_file/',
			//       description: ['candidate_upload_file_api_description'],
			//       table: {
			//         columns: [
			//           {
			//             heading: `${'parameter'}`,
			//             accessor: 'parameter'
			//           },
			//           {
			//             heading: `${'type'}`,
			//             accessor: 'type'
			//           },
			//           {
			//             heading: `${'description'}`,
			//             accessor: 'description'
			//           },
			//         ],
			//         data: [
			//           {
			//             parameter: 'file',
			//             type: 'file',
			//             description: 'resume file'
			//           },
			//           {
			//             parameter: 'folder_name',
			//             type: 'string',
			//             description: 'folder_name of s3 bucket'
			//           },
			//         ]
			//       },
			//       requestObject: {
			//         id: 'upload-resume',
			//         method: "POST",
			//         endpoint: "/general/candidate_upload_file",
			//         host: "https://corder-api.mereos.eu/{version_number}",
			//         contentType: "application/json",
			//         body: {
			//           "file": "binary",
			//           folder_name: 'Folder name'
			//         }
			//       },
			//     },
			//     {
			//       id: 'upload-file',
			//       heading: 'upload_file',
			//       httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/general/upload_file/',
			//       description: ['upload_file_api_description'],
			//       table: {
			//         columns: [
			//           {
			//             heading: `${'parameter'}`,
			//             accessor: 'parameter'
			//           },
			//           {
			//             heading: `${'type'}`,
			//             accessor: 'type'
			//           },
			//           {
			//             heading: `${'description'}`,
			//             accessor: 'description'
			//           },
			//         ],
			//         data: [
			//           {
			//             parameter: 'folder_name',
			//             type: 'string',
			//             description: 'folder_name of s3 bucket'
			//           },
			//           {
			//             parameter: 'files',
			//             type: 'file',
			//             description: 'files in form Data'
			//           },
			//         ]
			//       },
			//       requestObject: {
			//         id: 'upload-file',
			//         method: "POST",
			//         endpoint: "/general/upload_file/",
			//         host: "https://corder-api.mereos.eu/{version_number}",
			//         contentType: "application/json",
			//         body: {
			//           "folder_name": "Example folder",
			//           "files": "binary",
			//         }
			//       },
			//     },
			//     {
			//       id: 'recognition',
			//       heading: 'recognition',
			//       httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/general/rekognition/',
			//       description: ['recognition_api_description'],
			//       table: {
			//         columns: [
			//           {
			//             heading: `${'parameter'}`,
			//             accessor: 'parameter'
			//           },
			//           {
			//             heading: `${'type'}`,
			//             accessor: 'type'
			//           },
			//           {
			//             heading: `${'description'}`,
			//             accessor: 'description'
			//           },
			//         ],
			//         data: [
			//           {
			//             parameter: 'image',
			//             type: 'file',
			//             description: 'image_param_description'
			//           },
			//         ]
			//       },
			//       requestObject: {
			//         id: 'recognition',
			//         method: "POST",
			//         endpoint: "/general/rekognition/",
			//         host: "https://corder-api.mereos.eu/{version_number}",
			//         contentType: "application/json",
			//         body: {
			//           "image": "binary",
			//         }
			//       },
			//     },
			//     {
			//       id: 'info',
			//       heading: 'info',
			//       httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/general/info/',
			//       description: ['info_api_description'],
			//       table: {
			//         columns: [
			//           {
			//             heading: `${'parameter'}`,
			//             accessor: 'parameter'
			//           },
			//           {
			//             heading: `${'type'}`,
			//             accessor: 'type'
			//           },
			//           {
			//             heading: `${'description'}`,
			//             accessor: 'description'
			//           },
			//         ],
			//         data: [
			//           {
			//             parameter: 'name',
			//             type: 'string',
			//             description: 'name_param_description'
			//           },
			//           {
			//             parameter: 'gender',
			//             type: 'string',
			//             description: 'gender of person'
			//           },
			//           {
			//             parameter: 'city',
			//             type: 'string',
			//             description: 'city_param_description'
			//           }
			//         ]
			//       },
			//       requestObject: {
			//         id: 'info',
			//         method: "POST",
			//         endpoint: "/general/info/",
			//         host: "https://corder-api.mereos.eu/{version_number}",
			//         contentType: "application/json",
			//         body: {
			//           "name": "John Doe",
			//           "gender": "Male",
			//           "city": "city"
			//         }
			//       },
			//     }
			//   ]
			// },

			// ---------------- Instructor Group ---------------
			{
				id: 'instructor',
				heading: 'Instructor',
				groupDescription: 'instructor_group_description',
				subSections: [
					{
						id: 'create-instructor',
						heading: 'create_instructor',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/schools/instructor/',
						description: ['create_instructor_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'first_name',
									type: 'string',
									description: 'first_name_param_description'
								},
								{
									parameter: 'last_name',
									type: 'string',
									description: 'last_name_param_description'
								},
								{
									parameter: 'username',
									type: 'string',
									description: 'username_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'default_profile_id',
									type: 'integer',
									description: 'default_profile_id_param_description'
								},
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								},
								{
									parameter: 'external_id',
									type: 'integer',
									description: 'external_id_param_description'
								},
								{
									parameter: 'phone_number',
									type: 'integer',
									description: 'phone_number_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-instructor',
							method: "POST",
							endpoint: "/schools/instructor/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"first_name": "John",
								"last_name": "Doe",
								"username": "john_doe",
								"email": "john.doe@example.com",
								"school": 1,
								"default_profile_id": "123",
								"external_id": "123",
								"phone_number": 4877888
							}
						},
					},
					{
						id: 'edit-instructor',
						heading: 'edit_instructor',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/schools/instructor/',
						description: ['edit_instructor_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'last_login',
									type: 'date',
									description: 'last_login_param_description'
								},
								{
									parameter: 'is_superuser',
									type: 'boolean',
									description: 'is_superuser_param_description'
								},
								{
									parameter: 'username',
									type: 'string',
									description: 'username_param_description'
								},
								{
									parameter: 'first_name',
									type: 'string',
									description: 'first_name_param_description'
								},
								{
									parameter: 'last_name',
									type: 'string',
									description: 'last_name_param_description'
								},
								{
									parameter: 'role',
									type: 'integer',
									description: 'role_param_description'
								},
								{
									parameter: 'default_profile_id',
									type: 'string',
									description: 'default_profile_id_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								},
								{
									parameter: 'time_zone',
									type: 'string',
									description: 'time_zone_param_description'
								},
								{
									parameter: 'phone_number',
									type: 'string',
									description: 'phone_number_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-instructor',
							method: "PUT",
							endpoint: "/schools/instructor/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"id": 88,
								"email": "john.doe@example.com",
								"last_login": null,
								"is_superuser": false,
								"username": "john_doe",
								"first_name": "John",
								"last_name": "Doe",
								"role": 1,
								"default_profile_id": "123",
								"external_id": "123",
								"school": 1,
								"time_zone": null,
								"phone_number": null
							}
						},
					},
					{
						id: 'delete-instructor',
						heading: 'delete_instructor',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/schools/instructor/',
						description: ['delete_instructor_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-instructor',
							method: "DELETE",
							endpoint: "/schools/instructor/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"id": 4
							}
						}
					},
					{
						id: 'get-all-instructors',
						heading: 'get_all_instructors',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/v1.1.0/schools/instructor/?id=13&page=1&range=1&$expand=instructor',
						description: ['all_instructor_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-candidates',
							method: "GET",
							endpoint: "/v1.1.0/schools/instructor/?id=13&page=1&range=1&$expand=instructor",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								page: 1,
								range: 25,
							
								order_by: "id"}
						},
					},
					{
						id: 'create-school-instructor',
						heading: 'create_school_instructor',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/schools/create_instructor/',
						description: ['create_instructor_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'username',
									type: 'string',
									description: 'username_param_description'
								},
								{
									parameter: 'default_profile_id',
									type: 'string',
									description: 'default_profile_id_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'first_name',
									type: 'string',
									description: 'first_name_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'last_name',
									type: 'string',
									description: 'last_name_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'role',
									type: 'string',
									description: 'role_param_description'
								},
								{
									parameter: 'password',
									type: 'string',
									description: 'password_param_description'
								},
								{
									parameter: 'branch',
									type: 'string',
									description: 'branch_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-school-instructor',
							method: "POST",
							endpoint: "/schools/create_instructor/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"username": "john_doe",
								"default_profile_id": "123",
								"external_id": "123",
								"first_name": "John",
								"email": "john.doe@example.com",
								"last_name": "Doe",
								"created_at": "2025-12-02T12:24:06.807Z",
								"role": "4",
								"password": "********",
								"branch": "2"
							}
						},
					},
					{
						id: 'edit-school-instructor',
						heading: 'edit_school_instructor',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/schools/create_instructor/',
						description: ['edit_instructor_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'default_profile_id',
									type: 'string',
									description: 'default_profile_id_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'first_name',
									type: 'string',
									description: 'first_name_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'last_name',
									type: 'string',
									description: 'last_name_param_description'
								},
								{
									parameter: 'phone_number',
									type: 'string',
									description: 'phone_number_param_description'
								},
								{
									parameter: 'role',
									type: 'integer',
									description: 'role_param_description'
								},
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								},
								{
									parameter: 'username',
									type: 'string',
									description: 'username_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-instructor',
							method: "PUT",
							endpoint: "/schools/create_instructor/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"id": 16,
								"default_profile_id": "123",
								"email": "john.doe@example.com",
								"external_id": "123",
								"first_name": "John",
								"last_name": "Doe",
								"phone_number": null,
								"role": 4,
								"school": 2,
								"username": "john_doe"
							}
						},
					},
					{
						id: 'search-instructor',
						heading: 'search_instructor',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/schools/instructor_search/?page=1&range=1&search=John&$expand=role',
						description: ['search_instructor_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'search-instructor',
							method: "GET",
							endpoint: "/schools/instructor_search/?page=1&range=1&search=John&$expand=role",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								search: 'Candidate Name',
								page: 1,
								range: 25,
								q: `Q(created_at='2024-07-31T12:34:56')`,
								including_columns: 'owner'
							,
								order_by: "id"}
						},
					}
				]
			},

			// ---------------- Instructor Activity Group ---------------
			{
				id: 'instructor-activity',
				heading: 'Instructor Activity',
				groupDescription: 'instructor_activity_group_description',
				subSections: [
					{
						id: 'create-instructor-activity',
						heading: 'create_instructor_activity',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/schools/instructor-activities/',
						description: ['create_instructor_activity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'body',
									type: 'object',
									description: 'body_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'tags',
									type: 'object',
									description: 'tags_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-instructor-activity',
							method: "POST",
							endpoint: "/schools/instructor-activities/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"body": {
									"html": "<p>Hello World!</p>",
									"delta": []
								},
								"instructor": 25,
								"tags": {},
								"modify_at": "2024-10-01T13:01:27.604282Z",
								"created_at": "2024-10-01T13:01:27.604297Z"
							}
						},
					},
					{
						id: 'edit-instructor-activity',
						heading: 'edit_instructor_activity',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/schools/instructor-activities/',
						description: ['edit_instructor_activity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'body',
									type: 'object',
									description: 'body_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'tags',
									type: 'object',
									description: 'tags_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-instructor-activity',
							method: "PUT",
							endpoint: "/schools/instructor-activities/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"id": 2,
								"body": {
									"html": "<p>Hello World!</p>",
									"delta": []
								},
								"instructor": 25,
								"tags": {},
								"modify_at": "2024-10-01T13:04:16.363526Z",
								"created_at": "2024-10-01T13:04:16.363540Z"
							}
						},
					},
					{
						id: 'delete-instructor-activity',
						heading: 'delete_instructor_activity',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/schools/instructor-activities/',
						description: ['delete_instructor_activity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-instructor-activity',
							method: "DELETE",
							endpoint: "/schools/instructor-activities/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-instructor_activity',
						heading: 'get_all_instructors_activity',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/schools/instructor-activities/?page=1&range=1&$expand=instructor',
						description: ['all_instructor_activity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-candidates',
							method: "GET",
							endpoint: "/schools/instructor-activities/?page=1&range=1&$expand=instructor",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json"
						},
					},
					{
						id: 'search-instructor-activity',
						heading: 'search_instructor_activity',
						httpRequest: `GET https://corder-api.mereos.eu/{version_number}/schools/instructor_activities_search/?search=&page=1&range=1&$expand=instructor`,
						description: ['search_instructor_activity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'search-candidate',
							method: "GET",
							endpoint: "/schools/instructor_activities_search/?search=&page=1&range=1&$expand=instructor",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								search: '',
								page: 1,
								range: 25,
								$expand: 'instructor',
							
								order_by: "id"}
						},
					}
				]
			},

			// ---------------- Playlist Group ---------------
			{
				id: 'playlist',
				heading: 'Playlist',
				groupDescription: 'playlist_group_description',
				subSections: [
					{
						id: 'create-playlist',
						heading: 'create_playlist',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/playlists/playlist/',
						description: ['create_playlist_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'summary',
									type: 'array',
									description: 'summary_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'maximum_video',
									type: 'string',
									description: 'maximum_video_param_description'
								},
								{
									parameter: 'webcam_allowed',
									type: 'string',
									description: 'webcam_allowed_param_description'
								},
								{
									parameter: 'screen_allowed',
									type: 'string',
									description: 'screen_allowed_param_description'
								},
								{
									parameter: 'ai_logs',
									type: 'string',
									description: 'ai_logs_param_description'
								},
								{
									parameter: 'screen_logs',
									type: 'string',
									description: 'screen_logs_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'created_by',
									type: 'integer',
									description: 'created_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-playlist',
							method: "POST",
							endpoint: "/playlists/playlist/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"name": "Medical Playlist",
								"summary": [],
								"start_at": "2024-02-16T06:00:00Z",
								"end_at": "2024-02-22T00:00:00Z",
								"maximum_video": "2",
								"webcam_allowed": "Headphone",
								"screen_allowed": "Internet",
								"ai_logs": "Yes",
								"screen_logs": "Yes",
								"instructor": 11,
								"created_by": 11
							}
						},
					},
					{
						id: 'edit-playlist',
						heading: 'edit_playlist',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/playlists/playlist/',
						description: ['edit_playlist_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'settings',
									type: 'object',
									description: 'settings_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'created_by',
									type: 'integer',
									description: 'created_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-playlist',
							method: "PUT",
							endpoint: "/playlists/playlist/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 86,
								"name": "Medical Playlist",
								"description": null,
								"status": null,
								"start_at": "2024-02-16T06:00:00Z",
								"end_at": "2024-02-22T00:00:00Z",
								"settings": {},
								"modify_at": "2025-03-20T07:29:45.026334Z",
								"created_at": "2025-03-20T07:29:45.026362Z",
								"instructor": 25,
								"created_by": 11
							}
						},
					},
					{
						id: 'delete-playlist',
						heading: 'delete_playlist',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/playlists/playlist/',
						description: ['delete_playlist_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-playlist',
							method: "DELETE",
							endpoint: "/playlists/playlist/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'search-playlist',
						heading: 'search_playlist',
						httpRequest: `GET https://corder-api.mereos.eu/{version_number}/playlists/playlist_search/?search=&page=1&range=1&including_columns=instructor__email&instructor_id=8&q=Q(name="New playslit")&$expand=created_by`,
						description: ['search_playlist_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'including_columns',
									optional: true,
									type: 'string',
									description: 'including_columns_param_description'
								},
								{
									parameter: 'instructor_id',
									optional: true,
									type: 'integer',
									description: 'instructor_id_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'search-playlist',
							method: "GET",
							endpoint: `/playlists/playlist_search/?search=&page=1&range=1&including_columns=instructor__email&instructor_id=8&q=Q(name="New playslit")&$expand=created_by`,
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								search: 'Playlist Name',
								page: 1,
								range: 25,
								q: `Q(created_at='2024-07-31T12:34:56')`,
								including_columns: 'owner'
							,
								order_by: "id"}
						},
					},
					{
						id: 'duplicate-playlist',
						heading: 'duplicate_playlist',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/playlists/duplicate_playlist/',
						description: ['duplicate_playlist_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'playlist_name',
									optional: true,
									type: 'string',
									description: 'playlist_name_param_description'
								},
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'duplicate-playlist',
							method: "POST",
							endpoint: "/playlists/duplicate_playlist/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 67,
								"playlist_name": "New Playlist testing 3"
							}
						}
					},
					{
						id: 'playlist-with-sessions',
						heading: 'playlist_with_sessions',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/playlists/playlist_with_sessions/',
						description: ['create_playlist_wuth_session_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'settings',
									type: 'object',
									description: 'settings_param_description'
								},
								{
									parameter: 'sessions',
									type: 'array',
									description: 'sessions_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'created_by',
									type: 'integer',
									description: 'created_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-playlist',
							method: "POST",
							endpoint: "/playlists/playlist_with_sessions/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"instructor": 11,
								"name": "DropBox Playlist 2",
								"start_at": "2025-04-14T05:30:05.930649Z",
								"end_at": "2025-04-14T05:30:05.930649Z",
								"settings": {},
								"sessions": [
									4342
								],
								"modify_at": "2024-03-14T05:30:05.930649Z",
								"created_at": "2024-03-14T05:30:05.930661Z",
								"created_by": 11
							}
						},
					},
					{
						id: 'edit-playlist-with-sessions',
						heading: 'edit_playlist_with_sessions',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/playlists/playlist_with_sessions/',
						description: ['edit_playlist_with_session_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'created_by',
									type: 'integer',
									description: 'created_by_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'settings',
									type: 'object',
									description: 'settings_param_description'
								},
								{
									parameter: 'sessions',
									type: 'array',
									description: 'sessions_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-playlist-with-sessions',
							method: "PUT",
							endpoint: "/playlists/playlist_with_sessions/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 54,
								"instructor": 11,
								"created_by": 11,
								"name": "DropBox Playlist 1",
								"start_at": "2025-04-14T05:30:05.930649Z",
								"end_at": "2025-04-14T05:30:05.930649Z",
								"settings": {},
								"sessions": [
									4991
								],
								"status": "completed",
								"modify_at": "2024-03-14T05:30:05.930649Z",
								"created_at": "2024-03-14T05:30:05.930661Z",
							}
						},
					},
					{
						id: 'get-all-playlists',
						heading: 'get_all_playlists',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/playlists/playlist/?id=99&page=1&range=1&$expand=created_by',
						description: ['all_playlist_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-playlists',
							method: "GET",
							endpoint: "/playlists/playlist/?id=99&page=1&range=1&$expand=created_by",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								page: 1,
								range: 25,
							
								order_by: "id"}
						},
					}
				]
			},

			// ---------------- Secure Feature Profile Group ---------------
			{
				id: 'secure-feature-profile',
				heading: 'Secure Feature Profile',
				groupDescription: 'profile_group_description',
				subSections: [
					{
						id: 'create-profile',
						heading: 'create_profile',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/profiles/profile/',
						description: ['create_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'url_filter',
									type: 'array',
									description: 'url_filter_param_description'
								},
								{
									parameter: 'whitelist_urls',
									type: 'array',
									description: 'whitelist_urls_param_description'
								},
								{
									parameter: 'black_list_urls',
									type: 'array',
									description: 'black_list_urls_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'entities',
									type: 'array',
									description: 'entities_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-profile',
							method: "POST",
							endpoint: "/profiles/profile/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"name": "Localhost Profile Harvard",
								"description": "Localhost Profile One",
								"url_filter": [],
								"whitelist_urls": [],
								"black_list_urls": [],
								"modify_at": "2024-02-09T12:18:35.472074Z",
								"created_at": "2024-02-09T12:18:35.472151Z",
								"instructor": 8,
								"status": "Active",
								"entities": [
									5
								]
							}
						},
					},
					{
						id: 'edit-profile',
						heading: 'edit_profile',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/profiles/profile/',
						description: ['edit_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'settings',
									type: 'object',
									description: 'settings_param_description'
								},
								{
									parameter: 'detectable_objects',
									type: 'array',
									description: 'detectable_objects_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'entities',
									type: 'array',
									description: 'entities_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-profile',
							method: "PUT",
							endpoint: "/profiles/profile/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 227,
								"name": "Localhost Profile Harvard Update",
								"description": "Localhostt Profile One",
								"settings": {},
								"detectable_objects": [],
								"modify_at": "2025-07-17T06:16:04.997299Z",
								"created_at": "2025-07-17T06:14:46.066853Z",
								"instructor": 8,
								"entities": [
									5
								]
							}
						},
					},
					{
						id: 'delete-profile',
						heading: 'delete_profile',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/profile/secure_feature_profile/',
						description: ['delete_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-profile',
							method: "DELETE",
							endpoint: "/profile/secure_feature_profile/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-profiles',
						heading: 'get_all_profiles',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/profiles/profile/?id=223&q=12&page=1&range=2&$expand=id',
						description: ['all_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-profiles',
							method: "GET",
							endpoint: "/profiles/profile/?id=223&q=12&page=1&range=2&$expand=id",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								page: 1,
								range: 25,
							
								order_by: "id"}
						},
					},
					{
						id: 'search-profile',
						heading: 'search_profile',
						httpRequest: `GET https://corder-api.mereos.eu/{version_number}/profiles/profile_search/?search=&page=1&range=5&including_columns=instructor&q=Q(name="All Features - Except chatbot")&$expand=instructor`,
						description: ['search_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: 'including_columns',
									optional: true,
									type: 'array',
									description: 'including_columns_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'search-playlist',
							method: "GET",
							endpoint: `/profiles/profile_search/?search=&page=1&range=5&including_columns=instructor&q=Q(name="All Features - Except chatbot")&$expand=instructor`,
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								search: 'profile Name',
								page: 1,
								range: 25,
								q: `Q(created_at='2024-07-31T12:34:56')`,
								including_columns: 'owner'
							,
								order_by: "id"}
						},
					},
					{
						id: 'create-staff-profile',
						heading: 'create_staff_profile',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/profiles/staff_profile/',
						description: ['create_staff_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									optional: true,
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'whitelist_urls',
									optional: true,
									type: 'array',
									description: 'whitelist_urls_param_description'
								},
								{
									parameter: 'black_list_urls',
									optional: true,
									type: 'array',
									description: 'black_list_urls_param_description'
								},
								{
									parameter: 'settings',
									optional: true,
									type: 'object',
									description: 'settings_param_description'
								},
								{
									parameter: 'modify_at',
									optional: true,
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'instructor',
									optional: true,
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'entities',
									optional: true,
									type: 'array',
									description: 'entities_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-profile',
							method: "POST",
							endpoint: "/profiles/staff_profile/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"name": "Localhost Profile",
								"description": "Localhost Profile",
								"whitelist_urls": [],
								"black_list_urls": [],
								"settings": {},
								"modify_at": "2024-05-07T12:11:24.551579Z",
								"created_at": "2024-05-07T12:11:24.551640Z",
								"instructor": 8,
								"entities": [
									1
								]
							}
						},
					},
					{
						id: 'get-staff-profile',
						heading: 'get_staff_profile',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/profiles/staff_profile/',
						description: ['get_staff_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'get-staff-profile',
							method: "GET",
							endpoint: "/profiles/staff_profile/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								order_by: "id"
							}
						},
					},
					{
						id: 'edit-staff-profile',
						heading: 'edit_staff_profile',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/profiles/staff_profile/',
						description: ['edit_staff_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'whitelist_urls',
									type: 'array',
									description: 'whitelist_urls_param_description'
								},
								{
									parameter: 'black_list_urls',
									type: 'array',
									description: 'black_list_urls_param_description'
								},
								{
									parameter: 'settings',
									type: 'object',
									description: 'settings_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'entities',
									type: 'array',
									description: 'entities_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-staff-profile',
							method: "PUT",
							endpoint: "/profiles/staff_profile/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 15,
								"name": "Localhost Profile Updated",
								"description": "Localhost Profile Updated",
								"whitelist_urls": [],
								"black_list_urls": [],
								"settings": {},
								"modify_at": "2024-05-10T11:16:45.721788Z",
								"created_at": "2024-05-10T11:16:45.722038Z",
								"instructor": 8,
								"entities": [
									1
								]
							}
						},
					},
					{
						id: 'create-candidate-profile',
						heading: 'create_candidate_profile',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/profiles/candidate_profile/',
						description: ['create_candidate_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'url_filter',
									type: 'object',
									description: 'url_filter_param_description'
								},
								{
									parameter: 'whitelist_urls',
									type: 'object',
									description: 'whitelist_urls_param_description'
								},
								{
									parameter: 'black_list_urls',
									type: 'object',
									description: 'black_list_urls_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'string',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'string',
									description: 'created_at_param_description'
								},
								{
									parameter: 'instructor',
									type: 'number',
									description: 'instructor_param_description'
								},
								{
									parameter: 'entities',
									type: 'object',
									description: 'entities_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-candidate-profile',
							method: "POST",
							endpoint: "/profiles/candidate_profile/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"name": "Localhost Profile 1",
								"description": "Secure profile for localhost testing",
								"url_filter": {},
								"whitelist_urls": [
									"https://example.com",
									"https://localhost:3000"
								],
								"black_list_urls": [
									"https://facebook.com",
									"https://youtube.com"
								],
								"modify_at": "2026-02-11T10:30:00Z",
								"created_at": "2026-02-11T10:25:00Z",
								"instructor": 8,
								"entities": [1, 5, 9]
							}
						},
					},
					{
						id: 'edit-candidate-profile',
						heading: 'edit_candidate_profile',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/profiles/candidate_profile/',
						description: ['edit_candidate_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'whitelist_urls',
									type: 'array',
									description: 'whitelist_urls_param_description'
								},
								{
									parameter: 'blacklist_urls',
									type: 'array',
									description: 'blacklist_urls_param_description'
								},
								{
									parameter: 'detectable_objects',
									type: 'array',
									description: 'detectable_objects_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'settings',
									type: 'object',
									description: 'settings_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'entities',
									type: 'array',
									description: 'entities_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-candidate-profile',
							method: "PUT",
							endpoint: "/profiles/candidate_profile/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 201,
								"name": "Localhost Profile 1",
								"description": "Localhost Profile 1",
								"whitelist_urls": [],
								"blacklist_urls": [],
								"detectable_objects": [
									"book",
									"cell_phone",
									"remote"
								],
								"status": "Active",
								"settings": {},
								"modify_at": "2025-06-24T09:22:31.024198Z",
								"created_at": "2025-06-24T09:22:31.024214Z",
								"instructor": 11,
								"entities": [
									1
								]
							}
						},
					},
					{
						id: 'get-candidate-profile',
						heading: 'get_candidate_profile',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/profiles/candidate_profile/?id=12&page=1&range=1&$expand=instructor.branch.school',
						description: ['get_candidate_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-candidate-profile',
							method: "GET",
							endpoint: "/profiles/candidate_profile/?id=12&page=1&range=1&$expand=instructor.branch.school",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								page: 1,
								range: 25
							,
								order_by: "id"}
						},
					},
					{
						id: 'create-duplicate-profile',
						heading: 'create_duplicate_profile',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/profiles/duplicate_profile/',
						description: ['create_duplicate_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-duplicate-profile',
							method: "POST",
							endpoint: "/profiles/duplicate_profile/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 2,
								"name": "Samsung Profile"
							}
						},
					}
				]
			},

			// ---------------- Reports Group ---------------
			{
				id: 'reports',
				heading: 'Reports',
				groupDescription: 'reports_group_description',
				subSections: [
					{
						id: 'average-session-duration',
						heading: 'average_session_duration',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/reports/average_session_duration/',
						description: ['average_session_duration_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'average-session-duration',
							method: "POST",
							endpoint: "/reports/average_session_duration/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"start_at": "2024-03-30T05:55:09.702109Z",
								"end_at": "2025-07-30T05:55:09.702109Z"
							}
						},
					},
					{
						id: 'time-to-process',
						heading: 'time_to_process',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/reports/time_to_process/',
						description: ['time_to_process_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'time-to-process',
							method: "POST",
							endpoint: "/reports/time_to_process/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"start_at": "2024-03-30T05:55:09.702109Z",
								"end_at": "2025-07-30T05:55:09.702109Z"
							}
						},
					},
					{
						id: 'playlist-conversion-count-and-time',
						heading: 'playlist_conversion_count_and_time',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/reports/playlist_conversion_count_and_time/',
						description: ['playlist_conversion_count_and_time_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'playlist-conversion-count-and-time',
							method: "POST",
							endpoint: "/reports/playlist_conversion_count_and_time/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"start_at": "2024-03-30T05:55:09.702109Z",
								"end_at": "2025-07-30T05:55:09.702109Z"
							}
						},
					}
				]
			},

			// ---------------- Role Group ---------------
			{
				id: 'role',
				heading: 'Role',
				groupDescription: 'role_group_description',
				subSections: [
					{
						id: 'create-role',
						heading: 'create_role',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/schools/role/',
						description: ['create_role_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'features',
									type: 'array',
									description: 'features_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-role',
							method: "POST",
							endpoint: "/role/role/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"features": [
									{
										"id": 1,
										"name": "view_candidate",
										"description": "These feature enable user to perform candidate related features."
									},
									{
										"id": 2,
										"name": "view_assessment",
										"description": "These feature enable user to perform assessment related features."
									},
								],
								"name": "Master Recruiter",
								"description": "Some quick example text to build on the card title and make up the bulk of the card's content.",
							}
						},
					},
					{
						id: 'edit-role',
						heading: 'edit_role',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/schools/role/',
						description: ['edit_role_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'features',
									type: 'integer',
									description: 'features_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-role',
							method: "PUT",
							endpoint: "/schools/role/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 2,
								"name": "demo-update",
								"description": "demo-update",
								"created_at": "2024-02-12T07:26:40.079561Z",
								"features": 1
							}
						},
					},
					{
						id: 'delete-role',
						heading: 'delete_role',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/schools/role/',
						description: ['delete_role_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-role',
							method: "DELETE",
							endpoint: "/schools/role/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-role',
						heading: 'get_all_role',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/schools/role/',
						description: ['all_role_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'get-all-role',
							method: "GET",
							endpoint: "/schools/role/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								order_by: "id"
							}
						},
					}
				]
			},

			// ---------------- School Group ---------------
			{
				id: 'school',
				heading: 'School',
				groupDescription: 'school_group_description',
				subSections: [
					{
						id: 'create-school',
						heading: 'create_school',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/schools/school/',
						description: ['create_school_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'data_retention',
									type: 'string',
									description: 'data_retention_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'address',
									type: 'string',
									description: 'address_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'phone',
									type: 'string',
									description: 'phone_param_description'
								},
								{
									parameter: 'website',
									type: 'string',
									description: 'website_param_description'
								},
								{
									parameter: 'configurations',
									type: 'array',
									description: 'configurations_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'entities',
									type: 'array',
									description: 'entities_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-school',
							method: "POST",
							endpoint: "/schools/school/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"data_retention": "365",
								"external_id": null,
								"address": null,
								"description": null,
								"email": "john.doe@example.com",
								"name": "John Doe",
								"phone": "24242422424",
								"website": "example.com",
								"configurations": [],
								"status": "Inactive",
								"entities": [],
								"created_at": "2024-02-09T11:12:53.346999Z"
							}
						},
					},
					{
						id: 'edit-school',
						heading: 'edit_school',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/schools/school/v1.1.1',
						description: ['edit_school_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'data_retention',
									type: 'string',
									description: 'data_retention_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'address',
									type: 'string',
									description: 'address_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'phone',
									type: 'string',
									description: 'phone_param_description'
								},
								{
									parameter: 'website',
									type: 'string',
									description: 'website_param_description'
								},
								{
									parameter: 'configurations',
									type: 'array',
									description: 'configurations_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-school',
							method: "PUT",
							endpoint: "/schools/school/v1.1.1",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 2,
								"data_retention": "365",
								"external_id": null,
								"address": null,
								"description": null,
								"email": "john.doe@example.com",
								"name": "John Doe Updated",
								"phone": "24242422424",
								"website": "example.com",
								"configurations": [],
								"status": "Active",
								"created_at": "2024-02-15T10:39:08.434661Z"
							}
						},
					},
					{
						id: 'delete-school',
						heading: 'delete_school',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/schools/school/',
						description: ['delete_school_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-school',
							method: "DELETE",
							endpoint: "/schools/school/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-school',
						heading: 'get_all_school',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/schools/school/',
						description: ['all_school_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'get-all-school',
							method: "GET",
							endpoint: "/schools/school/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								order_by: "id"
							}
						},
					},
					{
						id: 'get-staff-school',
						heading: 'get_staff_school',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/schools/staff_school/',
						description: ['get_staff_school_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'get-staff-school',
							method: "GET",
							endpoint: "/schools/staff_school/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								order_by: "id"
							}
						},
					},
					{
						id: 'get-public-school',
						heading: 'get_public_school',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/schools/public_school/',
						description: ['get_public_school_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}
							]
						},
						requestObject: {
							id: 'get-public-school',
							method: "GET",
							endpoint: "/schools/public_school/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								order_by: "id"
							}
						},
					}
				]
			},

			// ---------------- Session Evaluation Group ---------------
			{
				id: 'session-evaluation',
				heading: 'Session Evaluation',
				groupDescription: 'session_evaluation_group_description',
				subSections: [
					{
						id: 'create-session-evaluation',
						heading: 'create_session_evaluation',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/sessions/evaluation/',
						description: ['create_session_evaluation_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'session',
									type: 'integer',
									description: 'session_param_description'
								},
								{
									parameter: 'description',
									type: 'object',
									description: 'description_param_description'
								},
								{
									parameter: 'evaluation',
									type: 'object',
									description: 'evaluation_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-session-evaluation',
							method: "POST",
							endpoint: "/sessions/evaluation/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"session": 3109,
								"description": {
									"html": "<p>Hello World!</p>",
									"delta": []
								},
								"evaluation": {
									"id_card": "fair",
									"id_card_comment": "this session was extra-ordinary"
								}
							}
						},
					},
					{
						id: 'edit-session-evaluation',
						heading: 'edit_session_evaluation',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/sessions/evaluation/',
						description: ['edit_session_evaluation_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'description',
									type: 'object',
									description: 'description_param_description'
								},
								{
									parameter: 'feedback',
									type: 'string',
									description: 'feedback_param_description'
								},
								{
									parameter: 'reports',
									type: 'array',
									description: 'reports_param_description'
								},
								{
									parameter: 'evaluation',
									type: 'object',
									description: 'evaluation_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'session',
									type: 'integer',
									description: 'session_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-session-evaluation',
							method: "PUT",
							endpoint: "/sessions/evaluation/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 45,
								"description": {
									"html": "<p>Hello World!</p>",
									"delta": []
								},
								"feedback": "Fair",
								"reports": [
									{
										"report_id": "RPT123",
										"details": "No anomalies detected"
									},
									{
										"report_id": "RPT124",
										"details": "Minor deviation in eye movement"
									}
								],
								"evaluation": {
									"accuracy": 95,
									"comments": "Good performance Updated"
								},
								"modify_at": "2025-03-20T08:30:57.860413Z",
								"created_at": "2025-03-20T08:30:57.860487Z",
								"session": 560,
								"status": "Active"
							}
						},
					},
					{
						id: 'delete-session-evaluation',
						heading: 'delete_session_evaluation',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/sessions/evaluation/',
						description: ['delete_session_evaluation_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-session-evaluation',
							method: "DELETE",
							endpoint: "/sessions/evaluation/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-session-evaluation',
						heading: 'get_all_session_evaluation',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/sessions/evaluation/?id=30&page=1&range=1&session=560',
						description: ['all_session_evaluation_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'session',
									optional: true,
									type: 'integer',
									description: 'session_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-session-evaluation',
							method: "GET",
							endpoint: "/sessions/evaluation/?id=30&page=1&range=1&session=560",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								page: 1,
								range: 25
							,
								order_by: "id"}
						},
					},
					{
						id: 'create-bulk-evaluation',
						heading: 'create_bulk_evaluation',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/sessions/bulk_evaluation/',
						description: ['create_bulk_evaluation_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'evaluations',
									type: 'array',
									description: 'evaluations_param_description'
								},
								{
									parameter: 'feedback',
									type: 'string',
									description: 'feedback_param_description'
								},
								{
									parameter: 'description',
									type: 'object',
									description: 'description_param_description'
								},
								{
									parameter: 'reports',
									type: 'array',
									description: 'reports_param_description'
								},
								{
									parameter: 'evaluation',
									type: 'object',
									description: 'evaluation_param_description'
								},
								{
									parameter: 'session',
									type: 'integer',
									description: 'session_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-session-evaluation',
							method: "POST",
							endpoint: "/sessions/bulk_evaluation/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"evaluations": [
									{
										"feedback": "Fair",
										"description": {
											"html": "<p>Hello World!</p>",
											"delta": []
										},
										"reports": [
											{
												"type": "audio",
												"status": "clear"
											}
										],
										"evaluation": {
											"score": 85,
											"remarks": "Good performance"
										},
										"session": 1
									},
									{
										"feedback": "Fraud",
										"description": {
											"html": "<p>Hello World!</p>",
											"delta": []
										},
										"reports": [
											{
												"type": "video",
												"status": "flagged"
											}
										],
										"evaluation": {
											"score": 45,
											"remarks": "Requires attention"
										},
										"session": 2
									}
								]
							}
						},
					},
					{
						id: 'edit-bulk-evaluation',
						heading: 'edit_bulk_evaluation',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/sessions/bulk_evaluation/',
						description: ['edit_bulk_evaluation_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'evaluations',
									type: 'array',
									description: 'evaluations_param_description'
								},
								{
									parameter: 'feedback',
									type: 'string',
									description: 'feedback_param_description'
								},
								{
									parameter: 'description',
									type: 'object',
									description: 'description_param_description'
								},
								{
									parameter: 'reports',
									type: 'array',
									description: 'reports_param_description'
								},
								{
									parameter: 'evaluation',
									type: 'object',
									description: 'evaluation_param_description'
								},
								{
									parameter: 'session',
									type: 'integer',
									description: 'session_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-bulk-evaluation',
							method: "PUT",
							endpoint: "/sessions/bulk_evaluation/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"evaluations": [
									{
										"id": 60,
										"description": {
											"html": "<p>Hello World!</p>",
											"delta": []
										},
										"feedback": "Fraud",
										"reports": [],
									}
								]
							}
						},
					},
					{
						id: 'search-evaluation',
						heading: 'search_evaluation',
						httpRequest: `GET https://corder-api.mereos.eu/{version_number}/sessions/evaluation_search/?search=hello&range=25&page=1`,
						description: ['search_evaluation_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
							
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'search-evaluation',
							method: "GET",
							endpoint: "/sessions/evaluation_search/?search=hello&range=25&page=1",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								search: 'Search Evaluation',
								page: 1,
								range: 25,
								q: `Q(created_at='2024-07-31T12:34:56')`,
							
								order_by: "id"}
						},
					}
				]
			},

			// ---------------- School Credentials Group ---------------
			// {
			//   id: 'school-credentials',
			//   heading: 'School Credentials',
			//   groupDescription: 'school_credentials_group_description',
			//   subSections: [
			//     {
			//       id: 'create-school-credentials',
			//       heading: 'create_school_credentials',
			//       httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/schools/school_credentials/',
			//       description: ['create_school_credentials_api_description'],
			//       table: {
			//         columns: [
			//           {
			//             heading: `${'parameter'}`,
			//             accessor: 'parameter'
			//           },
			//           {
			//             heading: `${'type'}`,
			//             accessor: 'type'
			//           },
			//           {
			//             heading: `${'description'}`,
			//             accessor: 'description'
			//           },
			//         ],
			//         data: [
			//           {
			//             parameter: 'client_id',
			//             type: 'string',
			//             description: 'client_id of oauth client'
			//           },
			//           {
			//             parameter: 'client_secret',
			//             type: 'string',
			//             description: 'client_secret of oauth client'
			//           },
			//           {
			//             parameter: 'school',
			//             type: 'integer',
			//             description: 'school_param_description'
			//           }
			//         ]
			//       },
			//       requestObject: {
			//         id: 'create-school-credentials',
			//         method: "POST",
			//         endpoint: "/schools/school_credentials/",
			//         host: "https://corder-api.mereos.eu/{version_number}/",
			//         contentType: "application/json",
			//         body: {
			//           "client_id": "123",
			//           "client_secret": "**********",
			//           "school": 1
			//         }
			//       },
			//     },
			//     {
			//       id: 'edit-school-credentials',
			//       heading: 'edit_school_credentials',
			//       httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/schools/school_credentials/',
			//       description: ['edit_school_credentials_api_description'],
			//       table: {
			//         columns: [
			//           {
			//             heading: `${'parameter'}`,
			//             accessor: 'parameter'
			//           },
			//           {
			//             heading: `${'type'}`,
			//             accessor: 'type'
			//           },
			//           {
			//             heading: `${'description'}`,
			//             accessor: 'description'
			//           },
			//         ],
			//         data: [
			//           {
			//             parameter: 'id',
			//             type: 'integer',
			//             description: 'id_param_description'
			//           },
			//           {
			//             parameter: 'client_id',
			//             type: 'string',
			//             description: 'client_id of oauth client'
			//           },
			//           {
			//             parameter: 'client_secret',
			//             type: 'string',
			//             description: 'client_secret of oauth client'
			//           },
			//           {
			//             parameter: 'modify_at',
			//             type: 'date',
			//             description: 'modify_at_param_description'
			//           },
			//           {
			//             parameter: 'created_at',
			//             type: 'date',
			//             description: 'created_at_param_description'
			//           },
			//           {
			//             parameter: 'school',
			//             type: 'integer',
			//             description: 'school_param_description'
			//           }
			//         ]
			//       },
			//       requestObject: {
			//         id: 'edit-school-credentials',
			//         method: "PUT",
			//         endpoint: "/schools/school_credentials/",
			//         host: "https://corder-api.mereos.eu/{version_number}/",
			//         contentType: "application/json",
			//         body: {
			//           "id": 2,
			//           "client_id": "123",
			//           "client_secret": "**********",
			//           "modify_at": "2024-10-11T09:50:59.671000Z",
			//           "created_at": "2024-10-11T09:50:59.671000Z",
			//           "school": 1
			//         }
			//       },
			//     },
			//     {
			//       id: 'delete-school-credentials',
			//       heading: 'delete_school_credentials',
			//       httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/schools/school_credentials/4/?id=2',
			//       description: ['delete_school_credentials_api_description'],
			//       table: {
			//         columns: [
			//           {
			//             heading: `${'parameter'}`,
			//             accessor: 'parameter'
			//           },
			//           {
			//             heading: `${'type'}`,
			//             accessor: 'type'
			//           },
			//           {
			//             heading: `${'description'}`,
			//             accessor: 'description'
			//           },
			//         ],
			//         data: [
			//           {
			//             parameter: 'id',
			//             type: 'integer',
			//             description: 'id_param_description'
			//           },
			//         ]
			//       },
			//       requestObject: {
			//         id: 'delete-school-credentials',
			//         method: "DELETE",
			//         endpoint: "/schools/school_credentials/4/?id=2",
			//         host: "https://corder-api.mereos.eu/{version_number}/",
			//         contentType: "application/json",
			//         body: {
			//           id: 2
			//         }
			//       }
			//     },
			//     {
			//       id: 'search-school-credentials',
			//       heading: 'search_school_credentials',
			//       httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/schools/school_credentials_search/?search=Mereos Dashboard&page=1&range=25',
			//       description: ['search_school_credentials_api_description'],
			//       table: {
			//         columns: [
			//           {
			//             heading: `${'parameter'}`,
			//             accessor: 'parameter'
			//           },
			//           {
			//             heading: `${'type'}`,
			//             accessor: 'type'
			//           },
			//           {
			//             heading: `${'description'}`,
			//             accessor: 'description'
			//           },
			//         ],
			//         data: [
			//           {
			//             parameter: 'search',
			//             type: 'string',
			//             description: 'search_param_description'
			//           },
			//           {
			//             parameter: 'page',
			//             type: 'integer',
			//             description: 'page_param_description'
			//           },
			//           {
			//             parameter: 'range',
			//             type: 'integer',
			//             description: 'range_param_description'
			//           }
			//         ]
			//       },
			//       requestObject: {
			//         id: 'search-school-credentials',
			//         method: "GET",
			//         endpoint: "/schools/school_credentials_search/?search=Mereos Dashboard&page=1&range=25",
			//         host: "https://corder-api.mereos.eu/{version_number}/",
			//         contentType: "application/json",
			//         body: {
			//           search: 'Mereos Dashboard',
			//           page: 1,
			//           range: 25,
			//           q: `Q(created_at='2024-07-31T12:34:56')`,
			//         }
			//       },
			//     },
			//     {
			//       id: 'get-school-credentials',
			//       heading: 'get_school_credentials',
			//       httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/schools/school_credentials/4/',
			//       description: ['get_school_credentials_api_description'],
			//       requestObject: {
			//         id: 'get-school-credentials',
			//         method: "GET",
			//         endpoint: "/schools/school_credentials/4/",
			//         host: "https://corder-api.mereos.eu/{version_number}/",
			//         contentType: "application/json",
			//       },
			//     }
			//   ]
			// },

			// ---------------- Sessions Group ---------------
			{
				id: 'sessions',
				heading: 'Sessions',
				groupDescription: 'sessions_group_description',
				subSections: [
					{
						id: 'get-session',
						heading: 'get_session',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/sessions/session/?id=10316&page=1&range=5&$expand=playlist',
						description: ['all_section_sessions_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-session',
							method: "GET",
							endpoint: "/sessions/session/?id=10316&page=1&range=5&$expand=playlist",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json"
						},
					},
					{
						id: 'create-session',
						heading: 'create_session',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/sessions/session/',
						description: ['create_section_sessions_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'archive_id',
									type: 'string',
									description: 'archive_id_param_description'
								},
								{
									parameter: 'attempt_id',
									type: 'string',
									description: 'attempt_id_param_description'
								},
								{
									parameter: 'duration_taken',
									type: 'string',
									description: 'duration_taken_param_description'
								},
								{
									parameter: 'identity_card',
									type: 'string',
									description: 'identity_card_param_description'
								},
								{
									parameter: 'identity_photo',
									type: 'string',
									description: 'identity_photo_param_description'
								},
								{
									parameter: 'incident_level',
									type: 'string',
									description: 'incident_level_param_description'
								},
								{
									parameter: 'questions_attempted',
									type: 'integer',
									description: 'questions_attempted_param_description'
								},
								{
									parameter: 'screen_sharing_video_name',
									type: 'string',
									description: 'screen_sharing_video_name_param_description'
								},
								{
									parameter: 'video_codec',
									type: 'string',
									description: 'video_codec_param_description'
								},
								{
									parameter: 'video_extension',
									type: 'string',
									description: 'video_extension_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'submission_time',
									type: 'date',
									description: 'submission_time_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'playlist',
									type: 'object',
									description: 'playlist_param_description'
								},
								{
									parameter: 'candidate_assessment',
									type: 'integer',
									description: 'candidate_assessment_param_description'
								},
								{
									parameter: 'library_version',
									type: 'string',
									description: 'library_version_for_create_session_description'
								}
							]
						},
						requestObject: {
							id: 'create-session',
							method: "POST",
							endpoint: "/sessions/session/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"archive_id": null,
								"attempt_id": null,
								"duration_taken": "2",
								"identity_card": null,
								"identity_photo": null,
								"incident_level": null,
								"questions_attempted": null,
								"screen_sharing_video_name": null,
								"video_codec": null,
								"video_extension": null,
								"status": "Completed",
								"submission_time": "2024-02-15T05:55:09.702109Z",
								"created_at": "2024-02-15T05:55:09.702131Z",
								"playlist": null,
								"candidate_assessment": 789,
								"library_version": "1.1.1"
							}
						},
					},
					{
						id: 'edit-session',
						heading: 'edit_session',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/sessions/session/',
						description: ['edit_section_sessions_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'collected_details',
									type: 'array',
									description: 'collected_details_param_description'
								},
								{
									parameter: 'mobile_audio_name',
									type: 'array',
									description: 'mobile_audio_name_param_description'
								},
								{
									parameter: 'user_video_name',
									type: 'array',
									description: 'user_video_name_param_description'
								},
								{
									parameter: 'archive_id',
									type: 'string',
									description: 'archive_id_param_description'
								},
								{
									parameter: 'duration_taken',
									type: 'string',
									description: 'duration_taken_param_description'
								},
								{
									parameter: 'identity_card',
									type: 'string',
									description: 'identity_card_param_description'
								},
								{
									parameter: 'identity_photo',
									type: 'string',
									description: 'identity_photo_param_description'
								},
								{
									parameter: 'incident_level',
									type: 'string',
									description: 'incident_level_param_description'
								},
								{
									parameter: 'questions_attempted',
									type: 'integer',
									description: 'questions_attempted_param_description'
								},
								{
									parameter: 'screen_sharing_video_name',
									type: 'string',
									description: 'screen_sharing_video_name_param_description'
								},
								{
									parameter: 'video_codec',
									type: 'string',
									description: 'video_codec_param_description'
								},
								{
									parameter: 'video_extension',
									type: 'string',
									description: 'video_extension_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'session_id',
									type: 'string',
									description: 'session_id_param_description'
								},
								{
									parameter: 'start_time',
									type: 'date',
									description: 'start_time_param_description'
								},
								{
									parameter: 'user_audio_name',
									type: 'array',
									description: 'user_audio_name_param_description'
								},
								{
									parameter: 'room_scan_video',
									type: 'array',
									description: 'room_scan_video_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'candidate',
									type: 'integer',
									description: 'candidate_param_description'
								},
								{
									parameter: 'playlist',
									type: 'integer',
									description: 'playlist_param_description'
								},
								{
									parameter: 'assessment',
									type: 'integer',
									description: 'assessment_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-session',
							method: "PUT",
							endpoint: "/sessions/session/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 46,
								"collected_details": [],
								"mobile_audio_name": [
									"test",
									"updated",
									"again",
									"dark"
								],
								"user_video_name": [],
								"archive_id": null,
								"duration_taken": "2 hours",
								"identity_card": null,
								"identity_photo": null,
								"incident_level": null,
								"questions_attempted": null,
								"screen_sharing_video_name": null,
								"video_codec": null,
								"video_extension": null,
								"status": "Completed",
								"session_id": null,
								"start_time": null,
								"user_audio_name": [],
								"room_scan_video": [],
								"modify_at": "2024-05-16T07:11:35.158783Z",
								"created_at": "2024-05-16T07:11:35.158795Z",
								"candidate": 2,
								"playlist": 31,
								"assessment": 8
							}
						},
					},
					{
						id: 'delete-session',
						heading: 'delete_session',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/sessions/session/',
						description: ['delete_section_sessions_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-session',
							method: "DELETE",
							endpoint: "/sessions/session/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'search-session',
						heading: 'search_session',
						httpRequest: `GET https://corder-api.mereos.eu/{version_number}/sessions/session_search/?search=hello&page=1&range=30&including_columns=owner&instructor_id=2&duplicate=False&$expand=playlist`,
						description: ['search_section_sessions_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'including_columns',
									optional: true,
									type: 'string',
									description: 'including_columns_param_description'
								},
								{
									parameter: 'instructor_id',
									optional: true,
									type: 'integer',
									description: 'instructor_id_param_description'
								},
								{
									parameter: 'duplicate',
									optional: true,
									type: 'boolean',
									description: 'duplicate_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'search-session',
							method: "GET",
							endpoint: "/sessions/session_search/?search=hello&page=1&range=30&including_columns=owner&instructor_id=2&duplicate=False&$expand=playlist",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								search: 'Search session',
								page: 1,
								range: 25,
								q: `Q(created_at='2024-07-31T12:34:56')`,
							
								order_by: "id"}
						},
					},
					{
						id: 'create-candidate-session',
						heading: 'create_candidate_session',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/sessions/candidate_session/',
						description: ['create_candidate_session_api'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'collected_details',
									type: 'array',
									description: 'collected_details_param_description'
								},
								{
									parameter: 'user_video_name',
									type: 'array',
									description: 'user_video_name_param_description'
								},
								{
									parameter: 'archive_id',
									type: 'string',
									description: 'archive_id_param_description'
								},
								{
									parameter: 'duration_taken',
									type: 'string',
									description: 'duration_taken_param_description'
								},
								{
									parameter: 'identity_card',
									type: 'string',
									description: 'identity_card_param_description'
								},
								{
									parameter: 'identity_photo',
									type: 'string',
									description: 'identity_photo_param_description'
								},
								{
									parameter: 'incident_level',
									type: 'string',
									description: 'incident_level_param_description'
								},
								{
									parameter: 'questions_attempted',
									type: 'integer',
									description: 'questions_attempted_param_description'
								},
								{
									parameter: 'screen_sharing_video_name',
									type: 'string',
									description: 'screen_sharing_video_name_param_description'
								},
								{
									parameter: 'video_codec',
									type: 'string',
									description: 'video_codec_param_description'
								},
								{
									parameter: 'video_extension',
									type: 'string',
									description: 'video_extension_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'mobile_video_name',
									type: 'array',
									description: 'mobile_video_name_param_description'
								},
								{
									parameter: 'mobile_audio_name',
									type: 'array',
									description: 'mobile_audio_name_param_description'
								},
								{
									parameter: 'session_id',
									type: 'string',
									description: 'session_id_param_description'
								},
								{
									parameter: 'start_time',
									type: 'date',
									description: 'start_time_param_description'
								},
								{
									parameter: 'user_audio_name',
									type: 'array',
									description: 'user_audio_name_param_description'
								},
								{
									parameter: 'room_scan_video',
									type: 'array',
									description: 'room_scan_video_param_description'
								},
								{
									parameter: 'ip_address',
									type: 'string',
									description: 'ip_address_param_description'
								},
								{
									parameter: 'os',
									type: 'string',
									description: 'os_param_description'
								},
								{
									parameter: 'browser',
									type: 'string',
									description: 'browser_param_description'
								},
								{
									parameter: 'location',
									type: 'object',
									description: 'location_param_description'
								},
								{
									parameter: 'mobile_session_id',
									type: 'string',
									description: 'mobile_session_id_param_description'
								},
								{
									parameter: 'conversation_id',
									type: 'string',
									description: 'conversation_id_param_description'
								},
								{
									parameter: 'playlist',
									type: 'object',
									description: 'playlist_param_description'
								},
								{
									parameter: 'candidate_assessment',
									type: 'object',
									description: 'candidate_assessment_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-candidate-session',
							method: "POST",
							endpoint: "/sessions/candidate_session/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"collected_details": [],
								"user_video_name": [],
								"archive_id": null,
								"duration_taken": "2 hours",
								"identity_card": null,
								"identity_photo": null,
								"incident_level": null,
								"questions_attempted": null,
								"screen_sharing_video_name": null,
								"video_codec": null,
								"video_extension": null,
								"status": "Completed",
								"mobile_video_name": [],
								"mobile_audio_name": [],
								"session_id": null,
								"start_time": null,
								"user_audio_name": [],
								"room_scan_video": [],
								"ip_address": "172.31.14.124",
								"os": "Other",
								"browser": "PostmanRuntime",
								"location": {},
								"mobile_session_id": null,
								"conversation_id": null,
								"playlist": null,
								"candidate_assessment": null
							}
						},
					},
					{
						id: 'edit-candidate-session',
						heading: 'edit_candidate_session',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/sessions/candidate_session/',
						description: ['edit_candidate_session_api'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'collected_details',
									type: 'array',
									description: 'collected_details_param_description'
								},
								{
									parameter: 'user_video_name',
									type: 'array',
									description: 'user_video_name_param_description'
								},
								{
									parameter: 'archive_id',
									type: 'string',
									description: 'archive_id_param_description'
								},
								{
									parameter: 'duration_taken',
									type: 'string',
									description: 'duration_taken_param_description'
								},
								{
									parameter: 'identity_card',
									type: 'string',
									description: 'identity_card_param_description'
								},
								{
									parameter: 'identity_photo',
									type: 'string',
									description: 'identity_photo_param_description'
								},
								{
									parameter: 'incident_level',
									type: 'string',
									description: 'incident_level_param_description'
								},
								{
									parameter: 'questions_attempted',
									type: 'integer',
									description: 'questions_attempted_param_description'
								},
								{
									parameter: 'screen_sharing_video_name',
									type: 'string',
									description: 'screen_sharing_video_name_param_description'
								},
								{
									parameter: 'video_codec',
									type: 'string',
									description: 'video_codec_param_description'
								},
								{
									parameter: 'video_extension',
									type: 'string',
									description: 'video_extension_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'mobile_video_name',
									type: 'array',
									description: 'mobile_video_name_param_description'
								},
								{
									parameter: 'mobile_audio_name',
									type: 'array',
									description: 'mobile_audio_name_param_description'
								},
								{
									parameter: 'session_id',
									type: 'string',
									description: 'session_id_param_description'
								},
								{
									parameter: 'start_time',
									type: 'date',
									description: 'start_time_param_description'
								},
								{
									parameter: 'user_audio_name',
									type: 'array',
									description: 'user_audio_name_param_description'
								},
								{
									parameter: 'room_scan_video',
									type: 'array',
									description: 'room_scan_video_param_description'
								},
								{
									parameter: 'ip_address',
									type: 'string',
									description: 'ip_address_param_description'
								},
								{
									parameter: 'os',
									type: 'string',
									description: 'os_param_description'
								},
								{
									parameter: 'browser',
									type: 'string',
									description: 'browser_param_description'
								},
								{
									parameter: 'location',
									type: 'object',
									description: 'location_param_description'
								},
								{
									parameter: 'mobile_session_id',
									type: 'string',
									description: 'mobile_session_id_param_description'
								},
								{
									parameter: 'conversation_id',
									type: 'string',
									description: 'conversation_id_param_description'
								},
								{
									parameter: 'playlist',
									type: 'object',
									description: 'playlist_param_description'
								},
								{
									parameter: 'candidate_assessment',
									type: 'object',
									description: 'candidate_assessment_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-candidate-session',
							method: "PUT",
							endpoint: "/sessions/candidate_session/",
							host: "https://corder-api.mereos.eu/{version_number}",
							contentType: "application/json",
							body: {
								"id": 1281,
								"collected_details": [],
								"user_video_name": [],
								"archive_id": null,
								"duration_taken": "2 hours",
								"identity_card": null,
								"identity_photo": null,
								"incident_level": null,
								"questions_attempted": null,
								"screen_sharing_video_name": null,
								"video_codec": null,
								"video_extension": null,
								"status": "Completed",
								"mobile_video_name": [],
								"mobile_audio_name": [],
								"session_id": null,
								"start_time": null,
								"user_audio_name": [],
								"room_scan_video": [],
								"ip_address": "172.31.15.95",
								"os": "Other updated",
								"browser": "PostmanRuntime",
								"location": {},
								"mobile_session_id": null,
								"conversation_id": null,
								"playlist": null,
								"candidate_assessment": null
							}
						},
					}
				]
			},

			// ---------------- Staffs Group ---------------
			{
				id: 'staffs',
				heading: 'Staffs',
				groupDescription: 'staffs_group_description',
				subSections: [
					{
						id: 'create-staffs',
						heading: 'create_staffs',
						httpRequest: 'POST https://corder-api.mereos.eu/{version_number}/staff/staff/',
						description: ['create_staff_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'external_name',
									type: 'string',
									description: 'external_name_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-staffs',
							method: "POST",
							endpoint: "/staff/staff/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"school": 1,
								"name": "John Doe",
								"email": "john.doe@example.com",
								"external_id": "john.doe@example.com",
								"external_name": "John Doe",
								"created_at": "2024-04-09T06:09:45.885947Z"
							}
						},
					},
					{
						id: 'edit-staffs',
						heading: 'edit_staffs',
						httpRequest: 'PUT https://corder-api.mereos.eu/{version_number}/staff/staff/',
						description: ['edit_staff_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'external_id',
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'external_name',
									type: 'string',
									description: 'external_name_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-staffs',
							method: "PUT",
							endpoint: "/staff/staff/",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								"id": 1,
								"school": 1,
								"name": "John Doe Updated",
								"email": "john.doe@example.com",
								"external_id": "123",
								"external_name": "John Doe",
								"created_at": "2024-04-09T06:09:45.885947Z"
							}
						},
					},
					{
						id: 'delete-staffs',
						heading: 'delete_staffs',
						httpRequest: 'DELETE https://corder-api.mereos.eu/{version_number}/staff/staff/?id=2',
						description: ['delete_staff_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'delete-staffs',
							method: "DELETE",
							endpoint: "/staff/staff/?id=2",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-staffs',
						heading: 'get_all_staffs',
						httpRequest: 'GET https://corder-api.mereos.eu/{version_number}/staff/staff/?id=1&page=1&range=1&$expand=school',
						description: ['all_staff_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
							,
								{
									parameter: 'order_by',
									optional: true,
									type: 'string',
									description: 'order_by_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-staffs',
							method: "GET",
							endpoint: "/staff/staff/?id=1&page=1&range=1&$expand=school",
							host: "https://corder-api.mereos.eu/{version_number}/",
							contentType: "application/json",
						},
					}
				]
			}
		]
	}
];
